import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import axios from "axios";
import AsyncSelect from "react-select/async";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import { confirmAlert } from "react-confirm-alert";
import CheckButton from "react-validation/build/button";
import CurrencyInput from "react-currency-input-field";
import Tooltip from "@tippyjs/react";
import SlidingPane from "react-sliding-pane";
import "tippy.js/dist/tippy.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MaterialTable, { MTableToolbar } from "material-table";
import { ArrowRight, Plus, Save, Search } from "lucide-react";

import Helper from "../../../../Helper";
import { API } from "../../../../backend";
import AddContractService from "../../../../services/contract/addContractService";
import { getTrans as t } from "../../../../Localization/translations";
import authHeader from "../../../../services/auth-header";
import GetCompanyInfoService from "../../../../services/company/getCompanyInfoService";
import AddPartyService from "../../../../services/party/addparty.service";
import AddPartyAddressService from "../../../../services/party/address/addAddress.service";
import AddAssetService from "../../../../services/contract/asset/addAssetService";
import AddPaymentScheduleService from "../../../../services/contract/paymentSchedule/addPaymentScheduleService";
import EditItemMasterService from "../../../../services/itemmaster/itemmasterEditServices";
import AddItemmasterService from "../../../../services/itemmaster/itemmasterAddService";
import AddVendor from "../../Vendor/addVendor";
import CreateAddress from "../../Address/createAddress";
import AddCutomer from "../../Customer/addCutomer";
import FilterAsset from "../../Asset/filterAsset";
import AddAsset from "../../Asset/addAsset";
import AddPayment from "../../Payment/addPayment";
import ContractLeaseSummary from "../../Summary/createSummary";
import lineOfBusinessService from "../../../../services/company/lineofbusinessService";
import subcompanyService from "../../../../services/company/subcompanyService";
import AddcategoryService from "../../../../services/category/categoryAddServices";

const CreateRental = () => {
  const location = useLocation();
  const states = location?.state;

  const [loading, setLoading] = useState(false);
  const [contract_number, setContract_number] = useState("");
  const [start_date, setStart_date] = useState(new Date());
  const [contract_term, setContract_term] = useState("");
  const [address, setAddress] = useState([]);
  const [address_id, setAdddressId] = useState();
  const [contract_type, setContract_type] = useState(states);
  const [contractID, setContractID] = useState();
  const [end_date, setEnd_date] = useState("");
  const [deposit_amount, setDeposit_amount] = useState(0);
  const [feesontime, setFeesOneTime] = useState(0);
  const [tax_rate_rent, setTax_Rate_Rent] = useState(0);
  const [tax_rate_fee, setTax_Rate_Fee] = useState(0);
  const [contract_number_method_disable, setContract_number_method_disable] =
    useState("");
  const [asset_type, setAssetType] = useState("");
  const [paymentrule, setPaymentRule] = useState("Advance");
  const [asset_typesetting, setAssetSettingType] = useState("");
  const [asset_typeselection, setAssetTypeSelection] = useState("");
  const [successful, setSuccessful] = useState(false);
  const [comment, setComment] = useState("");

  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    trigger,
    setError,
    reset,
    setValue,
    formState: { errors },
  } = useForm({ mode: 'onChange' });
  const form = useRef();
  const [extrafiledcontract, setExtraFiled] = useState([]);
  const [filedcontract, setFiledContract] = useState([
    { attribute0: "" },
    { attribute1: "" },
    { attribute2: "" },
    { attribute3: "" },
    { attribute4: "" },
    { attribute5: "" },
    { attribute6: "" },
    { attribute7: "" },
    { attribute8: "" },
    { attribute9: "" },
    { attribute10: "" },
    { attribute11: "" },
    { attribute12: "" },
    { attribute13: "" },
    { attribute14: "" },
  ]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputvalue, setInputValue] = useState("");

  // add party customer
  const form2 = useRef();
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    reset: reset2,
    formState: { errors: errors2 },
  } = useForm();
  const checkBtn2 = useRef();

  //party screen
  const [party_type, setParty_type] = useState("Customer");
  const [customer_type, setCustomer_type] = useState("Organization");
  const [showhide, setShowHide] = useState("");
  const [customer_name, setCustomer_name] = useState("");
  const [establishment_date, setEstablishment] = useState(null);
  const [date_of_birth, setDate_of_birth] = useState(null);
  const [disable, setDisable] = useState(false);

  //party screen
  const [party_typevendor, setParty_typeVendor] = useState("Vendor");
  const [customer_typevendor, setCustomer_typeVendor] =
    useState("Organization");
  const [customer_namevendor, setCustomer_nameVendor] = useState("");
  const [establishment_datevendor, setEstablishmentVendor] = useState(null);
  const [date_of_birthvendor, setDate_of_birthVednor] = useState(null);
  const [addCustomerSource, setAddCustomerSource] = useState(null);
  // Address Screen
  const [address_line_1, setAddress_line_1] = useState("");
  const [address_line_2, setAddress_line_2] = useState("");
  const [city, setCity] = useState("");
  const [stateaddress, setStateAddress] = useState("");
  const [zip_code, setZip_code] = useState("");
  const [country, setCountry] = useState("");
  const [country_name, setCountry_name] = useState([]);
  const [vendor_country_name, setVendor_Country_name] = useState([]);
  const [install_country_name, setInstall_Country_name] = useState([]);
  const [state_name, setState] = useState([]);
  const [install_state_name, setInstall_State] = useState([]);
  const [vendor_state_name, setVendor_State] = useState([]);
  const [countryid, setCountryid] = useState("");
  const [vendorcountryid, setVendorCountryid] = useState("");
  const [installcountryid, setInstallCountryid] = useState("");
  const [bill_to, setBill_to] = useState("Yes");
  const [ship_to, setShip_to] = useState("No");
  const [install_to, setInstall_to] = useState("Yes");

  const [vendoraddress_line_1, setVendorAddress_line_1] = useState("");
  const [vendoraddress_line_2, setVendorAddress_line_2] = useState("");
  const [vendorcity, setVendorCity] = useState("");
  const [vendorstateaddress, setVendorStateAddress] = useState("");
  const [vendorzip_code, setVendorZip_code] = useState("");
  const [vendorcountry, setVendorCountry] = useState("");
  const [vendorbill_to, setVendorBill_to] = useState("Yes");
  const [vendorship_to, setVendorShip_to] = useState("No");
  const [vendorinstall_to, setVendorInstall_to] = useState("Yes");
  // asset
  const [reg_address, setReg_address] = useState([]);
  const [installstateaddress, setInstallStateAddress] = useState("");
  const {
    register: register3,
    handleSubmit: handleSubmit3,
    reset: reset3,
    formState: { errors: errors3 },
  } = useForm();
  const form3 = useRef();

  const form4 = useRef();
  const checkBtn4 = useRef();
  const {
    register: register4,
    handleSubmit: handleSubmit4,
    reset: reset4,
    formState: { errors: errors4 },
  } = useForm();

  const form5 = useRef();
  const checkBtn5 = useRef();
  const {
    register: register5,
    handleSubmit: handleSubmit5,
    reset: reset5,
    formState: { errors: errors5 },
  } = useForm();

  const [achPayments, setAchPayments] = useState(false); // New state for ACH Payments checkbox
  const [achAccounts, setAchAccounts] = useState([]); // New state for ACH Accounts list
  const [achAccount, setAchAccount] = useState("");

  // New state variables for additional fields
  const [appOriginator, setAppOriginator] = useState("");
  const [source, setSource] = useState("");
  const [salesRep, setSalesRep] = useState("");
  const [subcompany, setSubcompany] = useState("");
  const [lineOfBusiness, setLineOfBusiness] = useState("");
  const [subcompanyOptions, setSubcompanyOptions] = useState([]);
  const [lineOfBusinessOptions, setLineOfBusinessOptions] = useState([]);

  const fetchAchAccounts = async (customerId) => {
    if (!customerId) {
      setAchAccounts([]);
      setAchAccount("");
      setAchPayments(false);
      setValue("achPayments", false); setValue("achAccount", "");
      return;
    }
    try {
      const response = await axios.get(
        `${API}parties/api/ach-accounts/?party_id=${customerId}`,
        { headers: authHeader() }
      );
      const accounts = response.data.details || [];
      setAchAccounts(accounts);
      // Set default ACH Payments based on customer data
      const customerResponse = await axios.get(
        `${API}parties/vendor/?party_type=Customer&&customer_name=${inputvalue}`,
        { headers: authHeader() }
      );
      const customer = customerResponse.data.data.find(
        (c) => c.id === customerId
      );
      console.log("Customer ACH Payments:", customer?.ACHPayments);
      // const achEnabled = customer?.ACHPayments || false;
      // setAchPayments(achEnabled);
      // const defaultAccount = accounts.find(
      //   (account) => account.is_default === true
      // );
      // const selectedAccountId = defaultAccount
      //   ? defaultAccount.id
      //   : accounts[0]?.id || "";
      // setAchAccount(selectedAccountId);
      // setValue("achPayments", achEnabled, achAccount: selectedAccountId);
    } catch (error) {
      console.error("Error fetching ACH accounts:", error);
      toast.error("Failed to load ACH accounts");
      setAchAccounts([]);
      setAchAccount("");
      setAchPayments(false);
      setValue("achPayments", false); setValue("achAccount", "");
    }
  };

  const fetchSubcompanies = () => {
    try {
      subcompanyService.getSubcompany().then((response) => {
        const companies = response.data || [];

        setSubcompanyOptions(companies);
        const defaultCompany = companies.find((company) => company.is_default);
        if (defaultCompany) {
          setSubcompany(defaultCompany.id);
          setValue("subcompany", defaultCompany.id)
        } else if (companies.length > 0) {
          // Fallback to first company if no default is set
          setSubcompany(companies[0].id);
          setValue("subcompany", companies[0].id)
        }
      });
    } catch (err) {
      console.error(err);
    }
  };

  // Fetch Lines of Business
  const fetchLinesOfBusiness = () => {
    try {
      lineOfBusinessService.getLineOfBusiness().then((response) => {
        const lobs = response.data || [];
        setLineOfBusinessOptions(lobs);
        setLineOfBusinessOptions(lobs);
        // Auto-select the LOB with is_default: true
        const defaultLob = lobs.find((lob) => lob.is_default);
        if (defaultLob) {
          setLineOfBusiness(defaultLob.id);
          setValue("lineOfBusiness", defaultLob.id)
        }
        // else if (lobs.length > 0) {
        //   // Fallback to first LOB if no default is set
        //   setLineOfBusiness(lobs[0].id);
        //   reset({
        //     lineOfBusiness:lobs[0].id
        //   })
        // }
      });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchAchAccounts(selectedValue);
    fetchSubcompanies();
    fetchLinesOfBusiness();
  }, [selectedValue]);

  useEffect(() => {
    if (subcompanyOptions.length > 0) {
      const defaultCompany = subcompanyOptions.find((c) => c.is_default) || subcompanyOptions[0];
      if (defaultCompany) {
        setSubcompany(defaultCompany.id);
        setValue("subcompany", defaultCompany.id);
      }
    }
  }, [subcompanyOptions]);

  useEffect(() => {
    if (lineOfBusinessOptions.length > 0) {
      const defaultLob = lineOfBusinessOptions.find((lob) => lob.is_default);
      if (defaultLob) {
        setLineOfBusiness(defaultLob.id);
        setValue("lineOfBusiness", defaultLob.id);
      }
    }
  }, [lineOfBusinessOptions]);

  const [reg_address1, setReg_address1] = useState(null);
  const [vehicle_cost, setVehicle_cost] = useState(0);
  const [vendor_name, setVendorName] = useState([]);
  const [vendername1, setVendorName1] = useState(null);
  const [asset_number, setAsset_number] = useState("");
  const [asset_desc, setAsset_desc] = useState(null);
  const [license_number, setLicense_number] = useState(null);
  const [year, setYear] = useState(null);
  const [vin_number, setVin_number] = useState(null);
  const [license_state, setLicense_state] = useState(null);
  const [manufacturer, setManufacturer] = useState(null);
  const [make, setMake] = useState(null);
  const [model, setModel] = useState(null);
  const [user_purpose, setUser_purpose] = useState(null);
  const [residal_value, setResidal_value] = useState(0);
  const [delivery_date, setDelivery_date] = useState(null);
  const [in_service_date, setIn_service_date] = useState(null);
  const [milage, setMilage] = useState(0);
  const [tax_amount, setTax_amount] = useState(0);
  const [tax_amount_payto, setTax_amount_payto] = useState("Dealer");
  const [trade_in, setTrade_in] = useState(0);
  const [trade_in_payto, setTrade_in_payto] = useState("Borrower");
  const [reg_cost, setReg_cost] = useState(0);
  const [reg_cost_payto, setReg_cost_payto] = useState("Dealer");
  const [down_payment, setDown_payment] = useState(0);
  const [down_payment_payto, setDown_payment_payto] = useState("Borrower");
  const [vehicle_cost_payto, setVehicle_cost_payto] = useState("Dealer");

  // payment
  const [payment_type, setPayment_type] = useState("Rent");
  const [no_of_payments, setNo_of_payments] = useState(null);
  const [amount, setAmount] = useState(null);
  const [frequency, setFrequency] = useState("Monthly");
  const [paymentstart_date, setPaymentStart_date] = useState("");
  const [Paymentend_date, setPaymentEnd_date] = useState(null);

  const [isExpanded, setIsExpanded] = useState(false);
  const [pacakge, setPackage] = useState([]);
  const [companydata, setCompany] = useState([]);
  const [disablebutton, setDisablebutton] = useState(false);

  const [selectedAddress, setSelectedAddress] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState([]);

  const [selectedBill, setSelectedBill] = useState(null);
  const [filterBill, setFilterBill] = useState([]);

  const [formData, setFormData] = useState({});
  const [isEquipment, setIsEquipment] = useState(false);

  const [rowsData, setRowsData] = useState([]);
  const [termError, setTermError] = useState("");

  const [paymentFrequency, setPaymentFrequency] = useState([
    { value: 1, label: "Monthly" },
    { value: 3, label: "Quarterly" },
    { value: 6, label: "Semi-annual" },
    { value: 12, label: "Annual" },
  ]);

  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 5;

  const nextStep = () => {
    setCurrentStep(Math.min(currentStep + 1, totalSteps));
  };

  const prevStep = () => {
    setCurrentStep(Math.max(currentStep - 1, 1));
    reset(undefined, { keepValues: true, keepErrors: false });
  };
  const handleNextClick = async (e) => {
    e.preventDefault();

    let fieldsToValidate = [];

    if (currentStep === 1) {
      fieldsToValidate = [
        "selectedValue",
        "billto",
        "address_id",
        "startdate",
        "contract_term",
      ];
      if (contract_number_method_disable === "Manual") {
        fieldsToValidate.push("contract_number");
      }
    } else if (currentStep === 2) {
      fieldsToValidate = [
        "vendorname1",
        "assettype",
        "vehiclecost",
        "asset_desc",
      ];
    } else if (currentStep === 3) {
      fieldsToValidate = ["frequency", "paymentrule", "paymentamount"];
      if (achPayments && !achAccount) {
        setError("achAccount", {
          type: "manual",
          message: "Please select Bank Account for ACH Payments",
        });
        return;
      }
    }
    else if (currentStep === 4) {
      fieldsToValidate = ["party", "role"];
    }

    try {
      const isValid = await trigger(fieldsToValidate);

      if (isValid) {
        nextStep();
      } else {
        const invalidFields = fieldsToValidate.filter(
          (field) => !!errors[field]
        );
      }
    } catch (error) {
      toast.error("An error occurred during validation");
    }
  };
  const toggleFields = () => {
    setIsExpanded(!isExpanded);
  };

  const isFirstDayOfMonth = (date) => {
    return date.getDate() === 1;
  };

  const setenddate = (no_of_payments) => {
    if (start_date === "") {
      return false;
    }

    var contractDateObj = new Date(start_date);
    const frequencyMapping = {
      Monthly: { months: 1 },
      Quarterly: { months: 3 },
      "Semi-annual": { months: 6 },
      Annual: { months: 12 },
    };
    let paymentStartDate, paymentEndDate;
    if (paymentrule === "Advance") {
      paymentStartDate = contractDateObj;
    } else if (paymentrule === "Arrears") {
      const cycleDelta = frequencyMapping[frequency];
      if (isFirstDayOfMonth(contractDateObj)) {
        paymentStartDate = new Date(contractDateObj);
        paymentStartDate = new Date(
          paymentStartDate.getFullYear(),
          paymentStartDate.getMonth() + cycleDelta.months,
          1
        );
        paymentStartDate.setDate(paymentStartDate.getDate() - 1);
      } else {
        paymentStartDate = new Date(contractDateObj);
        paymentStartDate.setMonth(
          paymentStartDate.getMonth() + cycleDelta.months
        );
        paymentStartDate.setDate(paymentStartDate.getDate() - 1);
      }
    }
    paymentEndDate = new Date(contractDateObj);
    paymentEndDate.setMonth(
      paymentEndDate.getMonth() + parseInt(contract_term)
    );
    paymentEndDate.setDate(paymentEndDate.getDate() - 1);

    setPaymentStart_date(Helper.DatePicker(paymentStartDate));
    if (paymentEndDate !== "Invalid Date") {
      setPaymentEnd_date(Helper.DatePicker(paymentEndDate));
    }
  };

  const getinstalladdress = async (id) => {
    if (id !== undefined) {
      if (selectedValue !== null) {
        const resst = await fetch(
          API +
          "parties/manage-address/" +
          selectedValue +
          "/?address_type=install_to",
          { headers: authHeader() }
        );
        const getst = await resst.json();
        setReg_address(await getst.data);
        setReg_address1(id);
        setValue("address_id", id,);
      }
    } else {
      if (selectedValue !== null) {
        const resst = await fetch(
          API +
          "parties/manage-address/" +
          selectedValue +
          "/?address_type=install_to",
          { headers: authHeader() }
        );
        const getst = await resst.json();
        setReg_address(await getst.data);
        setReg_address1(await getst.data[0].id);
        setValue("address_id", await getst.data[0].id,);
      }
    }
  };

  const [state1, setState1] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [state2, setState2] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [state4, setState4] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [state3, setState3] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const [state5, setState5] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const form6 = useRef();
  const checkBtn6 = useRef();
  const {
    register: register6,
    handleSubmit: handleSubmit6,
    reset: reset6,
    // formState: { errors: errors5 },
  } = useForm();

  const [frequencyMapped, setFrequencyMapped] = useState({
    Monthly: 1,
    Quarterly: 3,
    SemiAnnual: 6,
    Annual: 12,
  });
  const [paymentType, setPaymentType] = useState([]);

  const handelDefault = async () => {
    const rsst = await fetch(API + "parties/vendor/?party_type=Vendor", {
      headers: authHeader(),
    });
    const gtst = await rsst.json();
    setVendorName(await gtst);
  };

  const handleshowhide = (e) => {
    const getuser = e.target.value;
    setCustomer_type(e.target.value);
    setShowHide(getuser);
  };
  const handleshowhidevendor = (e) => {
    const getuser = e.target.value;
    setCustomer_typeVendor(e.target.value);
  };

  const handleAddress = (id) => {
    form2.current.validateAll();
    if (checkBtn2.current.context._errors.length === 0) {
      AddPartyAddressService.addPartyAddress(
        id,
        address_line_1,
        address_line_2,
        city,
        stateaddress,
        zip_code,
        country,
        bill_to,
        ship_to,
        install_to
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setAddress_line_1("");
          setAddress_line_2("");
          setCity("");
          setStateAddress("");
          setZip_code("");
        }
      });
    }
  };

  const handleAddressVendor = (id) => {
    form4.current.validateAll();
    if (checkBtn4.current.context._errors.length === 0) {
      AddPartyAddressService.addPartyAddress(
        id,
        vendoraddress_line_1,
        vendoraddress_line_2,
        vendorcity,
        vendorstateaddress,
        vendorzip_code,
        vendorcountry,
        vendorbill_to,
        vendorship_to,
        vendorinstall_to
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setVendorAddress_line_1("");
          setVendorAddress_line_2("");
          setVendorCity("");
          setVendorStateAddress("");
          setVendorZip_code("");
        }
      });
    }
  };

  const handleparty = () => {
    form2.current.validateAll();
    let establishmentDate = null;
    let dateofbirth = null;
    if (checkBtn2.current.context._errors.length === 0) {
      if (date_of_birth) {
        dateofbirth = Helper.DatePicker(date_of_birth);
      } else {
        setDate_of_birth(date_of_birth);
      }
      if (establishment_date) {
        establishmentDate = Helper.DatePicker(establishment_date);
      } else {
        setEstablishment(establishment_date);
      }
      AddPartyService.addParty(customer_type, party_type, customer_name).then(
        (response) => {
          if (response.data.success) {
            setSuccessful(true);
            setDisable(true);
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            // handleAddress(response.data.partyId);
            // loadInitialOptions();
            // reset({
            //   selectedValue: response.data.partyId,
            // });
            // setTimeout(() => {
            //   setSelectedValue(response.data.partyId);
            //   setState1({ isPaneOpen: false });
            // }, 1000);

            // AFTER
            if (addCustomerSource === 'step1') {
              handleAddress(response.data.partyId);
              loadInitialOptions();
              setValue("selectedValue", response.data.partyId);
              setTimeout(() => {
                setSelectedValue(response.data.partyId);
                setState1({ isPaneOpen: false });
              }, 1000);
            } else if (addCustomerSource === 'step4') {
              loadInitialOptionspartyRole();
              setTimeout(() => {
                setSelectedParty({ id: response.data.partyId, customer_name: customer_name });
                setState1({ isPaneOpen: false });
              }, 1000);
            }
            setAddCustomerSource(null);

            setCustomer_name("");
            setCustomer_type("");
          } else {
            setLoading(false);
            setSuccessful(false);
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 9000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        }
      );
    }
  };

  const handlepartydefault = () => {
    AddPartyService.partyvalidate(customer_name).then((response) => {
      if (response.data.success) {
        handleparty();
      } else {
        confirmAlert({
          title: "",
          message: `Party ${customer_name} is available.`,
          // message:
          //   "Party Vendor with the same name already exist. Are you sure you want to add party vender?.",
          buttons: [
            {
              // label: "Yes",
              label: "OK",
              // onClick: () => handleparty(),
            },
            // {
            //   label: "No",
            // },
          ],
        });
      }
    });
  };

  const handleVendorparty = () => {
    form4.current.validateAll();
    let establishmentDate = null;
    let dateofbirth = null;
    if (checkBtn4.current.context._errors.length === 0) {
      if (date_of_birthvendor) {
        dateofbirth = Helper.DatePicker(date_of_birthvendor);
      } else {
        setDate_of_birth(date_of_birth);
      }
      if (establishment_datevendor) {
        establishmentDate = Helper.DatePicker(establishment_datevendor);
      } else {
        setEstablishment(establishment_date);
      }
      AddPartyService.addParty(
        customer_typevendor,
        party_typevendor,
        customer_namevendor
      ).then((response) => {
        if (response.data.success) {
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setValue("vendorname1", response.data.partyId,);
          setVendorName1(response.data.partyId);
          handleAddressVendor(response.data.partyId);
          setTimeout(() => {
            handelDefault();
            setState4({ isPaneOpen: false });
          }, 1000);
          setCustomer_nameVendor("");
        } else {
          setLoading(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 9000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      });
    }
  };

  const handlepartyvendor = () => {
    AddPartyService.partyvalidate(customer_namevendor).then((response) => {
      if (response.data.success) {
        handleVendorparty();
      } else {
        confirmAlert({
          title: "",
          message: `Party ${customer_namevendor} is available.`,
          // message:
          //   "Party Vendor with the same name already exist. Are you sure you want to add party vender?.",
          buttons: [
            {
              // label: "Yes",
              label: "OK",
              // onClick: () => handleVendorparty(),
            },
            // {
            //   label: "No",
            // },
          ],
        });
      }
    });
  };

  const handelInputChange = (value) => {
    setInputValue(value);
  };

  const handelChange = (value) => {
    if (value === null) {
      setSelectedValue(value);
      setValue("selectedValue", value, { shouldValidate: true });
      setAddress([]);
      setAdddressId("");
      setReg_address1("");
      setReg_address([]);
    } else {
      setSelectedValue(value.id);
      setValue("selectedValue", value.id, { shouldValidate: true });
      getaddress();
      getinstalladdress();
    }
  };

  const loadOptions = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API +
        `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const [options, setOptions] = useState([]);
  const loadInitialOptions = async () => {
    const responseJSON = await axios.get(
      API +
      `parties/vendor/?party_type=Customer&&customer_name=${customer_name}`,
      { headers: authHeader() }
    );
    setOptions(responseJSON.data.data);
  };

  const contract_number_method = async () => {
    await axios
      .get(API + `contracts/contract_number_method/`, { headers: authHeader() })
      .then((response) => {
        if (response.data.success === 1) {
          setContract_number_method_disable(response.data.details);
        } else {
          confirmAlert({
            title: "",
            message: "Go to settings and update CompanySettings",
            buttons: [
              {
                label: "OK",
                onClick: () => navigate("/profile"),
              },
            ],
          });
        }
      });
  };

  const asset_number_method = async () => {
    await axios
      .get(API + `contracts/asser_number_series/`, { headers: authHeader() })
      .then((response) => {
        if (response.data.success === 1) {
          setAssetType(response.data.assettype.split(", "));
          setAssetSettingType(response.data.assettype);
        } else {
          return false;
        }
      });
  };

  const handelStart_Date = (value) => {
    setStart_date(value);
    setValue("startdate", value,);
  };

  useEffect(() => {
    contract_number_method();
    asset_number_method();
    loadInitialOptions();
    setValue("startdate", start_date,);
  }, []);

  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existcontract);
    });
  };

  const packagedata = async () => {
    const res = await fetch(API + "company/packages/", {
      headers: authHeader(),
    });
    const getcon = await res.json();
    setPackage(getcon);
  };
  const company = () => {
    GetCompanyInfoService.getCompanyInfo().then((response) => {
      setInstallCountryid(response.data.country);
      setCountryid(response.data.country);
      setVendorCountryid(response.data.country);
      setCompany(response.data);
    });
  };
  useEffect(() => {
    packagedata();
    company();
  }, []);
  const free = pacakge.filter((value) => value.name === companydata.plan);

  useEffect(() => {
    getExtrafiled();
    getEndDate();
    setPaymentStart_date(start_date);
    setNo_of_payments(contract_term);
    setValue("paymentstartdate", start_date);
    setValue("nopayyments", contract_term);
    setValue("startdate", start_date);
  }, [start_date, contract_term, end_date, paymentrule]);

  useEffect(() => {
    if (frequency === "Monthly") {
      setenddate(contract_term / 1);
      setNo_of_payments(contract_term / 1);
    }
    if (frequency === "Quarterly") {
      setenddate(contract_term / 3);
      setNo_of_payments(contract_term / 3);
    }
    if (frequency === "Semi-annual") {
      setenddate(contract_term / 6);
      setNo_of_payments(contract_term / 6);
    }
    if (frequency === "Annual") {
      setenddate(contract_term / 12);
      setNo_of_payments(contract_term / 12);
    }
  }, [no_of_payments, paymentrule, frequency, paymentstart_date]);
  const onChangeextrafileds = (e, index) => {
    const { name, value } = e.target;
    const rowsInput = [...filedcontract];
    rowsInput[index][name] = value;
    setFiledContract(rowsInput);
  };

  const navigate = useNavigate();

  const handelContract_term = (value) => {
    setContract_term(value);
  };

  const getEndDate = () => {
    if (start_date === "") {
      return false;
    }
    var dt = new Date(start_date);
    var term = parseInt(contract_term);
    if (contract_term !== "" && !isNaN(dt)) {
      dt.setMonth(dt.getMonth() + term);
      dt.setDate(dt.getDate() - 1);
      setEnd_date(Helper.Dateview(dt));
    }
  };

  const getaddress = async () => {
    if (selectedValue !== null) {
      const resst = await fetch(
        API +
        "parties/manage-address/" +
        selectedValue +
        "/?address_type=bill_to",
        { headers: authHeader() }
      );
      const getst = await resst.json();
      setAddress(await getst.data);
      setAdddressId(await getst.data[0].id);
      setValue("billto", await getst.data[0].id, { shouldValidate: true });
    }
  };

  const loadOptionBillAdd = async (inputValue, callback) => {
    const filteredOptions = address
      .filter((address) =>
        `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
          .toLowerCase()
          .includes(inputValue.toLowerCase())
      )
      .map((address) => ({
        value: address.id,
        label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`,
      }));

    setFilterBill(filteredOptions);
    callback(filteredOptions);
  };

  useEffect(() => {
    const options = address.map((address) => ({
      value: address.id,
      label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`,
    }));
    setFilterBill(options);
  }, [address]);

  const handleBillAddressChange = (selectedOption) => {
    if (selectedOption) {
      setAdddressId(selectedOption.value);
      setValue("billto", selectedOption.value, { shouldValidate: true });
    } else {
      setAdddressId(null);
      setSelectedBill(null);
      setValue("billto", null, { shouldValidate: true });
    }
    trigger("billto");
  };

  useEffect(() => {
    if (address_id && filterBill.find((val) => val.value === address_id)) {
      trigger("billto");
    }
  }, [address_id, filterBill, trigger]);

  const handelvender = async () => {
    const rsst = await fetch(API + "parties/vendor/?party_type=Vendor", {
      headers: authHeader(),
    });
    const gtst = await rsst.json();
    setVendorName(await gtst);
  };
  useEffect(() => {
    getaddress();
    getinstalladdress();
    handelvender();
  }, [selectedValue]);

  const handlepaymentscreen = (id) => {
    setSuccessful(false);
    setLoading(true);
    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      AddPaymentScheduleService.addPaymentSchedule(
        id,
        no_of_payments,
        payment_type,
        amount,
        frequency,
        Helper.DatePicker(start_date),
        Helper.DatePicker(Paymentend_date),
        rowsData
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
        }
      });
    }
  };

  // const generateRandomSerialNumber = (length = 5) => {
  //   const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  //   let serialNumber = '';
  //   for (let i = 0; i < length; i++) {
  //     const randomIndex = Math.floor(Math.random() * chars.length);
  //     serialNumber += chars[randomIndex];
  //   }
  //   return serialNumber;
  // };

  const [category_list, setCategory_list] = useState([])
  const [sub_categories, setSub_categories] = useState([])
  const [selected_category, setSelected_category] = useState("")
  const [selected_sub_category, setselected_sub_category] = useState("")
  useEffect(() => {
    AddcategoryService.viewListCategory().then((response) => {
      setCategory_list(response.data.data.categories);
    });
  }, []);

  const handleCategoryChange = (e) => {
    const selectedValue = e.target.value;
    setSelected_category(selectedValue);
    handleItemType(selectedValue)
  }

  useEffect(() => {
    if (selected_category !== "") {
      const matchedCategory = category_list.find(
        (cat) => cat.id === Number(selected_category)
      )
      const category_name = matchedCategory.category_name;
      const item_types = matchedCategory?.item_type
      AddcategoryService.filtersubCategory(category_name).then((response) => {
        const fetchedSubCategories = response.data.sub_categories;
        setSub_categories(fetchedSubCategories);
        const defaultSubCategory = fetchedSubCategories.find(subCat => subCat.is_default === true);
        if (defaultSubCategory) {
          setselected_sub_category(defaultSubCategory.id.toString());
          setValue("subcategory", defaultSubCategory.id)
        } else {
          setselected_sub_category("");
        }
      });
      setValue("item_type", item_types)
    }
  }, [selected_category, category_list])

  const handlesubCategoryChange = (e) => {
    const selectedValue = e.target.value;
    setselected_sub_category(selectedValue);
  }

  const handleItemType = (selectedValue) => {
    const itemval = category_list.find((val) => val.id === parseInt(selectedValue))
    console.log(itemval?.item_type)
    if (itemval) {
      //   setAsset_type(itemval.item_type);
      setValue("item_type", itemval.item_type);
    } else {
      //   setAsset_type('');
      setValue("item_type", '');
    }
  }

  const handleCreateItem = (asset_id, financed_amt) => {
    let itemid = "";
    let description = asset_desc;
    let itemname = "";
    let serial_number = "";
    let life_in_months = null;
    let netbookvalue = vehicle_cost;
    let originalcost = financed_amt;
    let item_type = "";
    if (asset_type.length === 1) {
      item_type = asset_typesetting;
    } else {
      item_type = asset_typeselection;
    }
    let status = "In Transit";
    let category_id = selected_category !== "" ? selected_category : ""
    let sub_category_id = selected_sub_category !== "" ? selected_sub_category : ""
    AddItemmasterService.addItemmaster(
      itemid,
      itemname,
      description,
      serial_number,
      year,
      manufacturer,
      model,
      make,
      Date,
      life_in_months,
      netbookvalue,
      originalcost,
      status,
      asset_id,
      item_type,
      category_id,
      sub_category_id
    ).then((response) => {
      if (response.data.success === 1) {
        toast.success(`${response.data.response}`, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
      } else {
        setLoading(false);
        setDisable(false);
        toast.error(`${response.data.error}`, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    });
  };

  const handleExitingInventory = () => {
    let item_type = "";
    if (asset_type.length === 1) {
      item_type = asset_typesetting;
    } else {
      item_type = asset_typeselection;
    }
    if (item_type === "") {
      confirmAlert({
        title: "",
        message: "Please select asset type before select inventory.",
        buttons: [
          {
            label: "OK",
            onClick: () => {
              setState3({ isPaneOpen: false });
              setState6({ isPaneOpen: false });
            },
          },
        ],
      });
    } else {
      setState3({ isPaneOpen: false });
      setState6({ isPaneOpen: true });
    }
  };

  const handleRegisterasset = (id) => {
    const total_cost = parseFloat(vehicle_cost);
    const financed_amt = parseFloat(total_cost);
    const dealer_pay = parseFloat(total_cost);

    form.current.validateAll();
    let DelecieryDate = null;
    let Inservicedate = null;
    let assettype = "";
    if (checkBtn.current.context._errors.length === 0) {
      if (in_service_date) {
        Inservicedate = Helper.DatePicker(in_service_date);
      } else {
        setIn_service_date(in_service_date);
      }
      if (delivery_date) {
        DelecieryDate = Helper.DatePicker(delivery_date);
      } else {
        setDelivery_date(delivery_date);
      }
      if (vehicle_cost <= 0) {
        toast.error("Please enter valid Vehical Cost ", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoading(false);
        return false;
      }
      if (asset_type.length === 1) {
        assettype = asset_typesetting;
      } else {
        assettype = asset_typeselection;
      }
      AddAssetService.addAsset(
        id,
        asset_number,
        formData.asset_desc ? formData.asset_desc : asset_desc,
        formData.license_number ? formData.license_number : license_number,
        financed_amt,
        formData.year ? formData.year : year,
        formData.vin_number ? formData.vin_number : vin_number,
        formData.license_state ? formData.license_state : license_state,
        dealer_pay,
        formData.manufacturer ? formData.manufacturer : manufacturer,
        formData.make ? formData.make : make,
        formData.model ? formData.model : model,
        user_purpose,
        formData.residulevalue ? formData.residulevalue : residal_value,
        reg_address1,
        vendername1,
        DelecieryDate,
        formData.in_service_date
          ? Helper.DatePicker(formData.in_service_date)
          : Inservicedate,
        formData.mileage ? formData.mileage : milage,
        vehicle_cost,
        vehicle_cost_payto,
        tax_amount,
        tax_amount_payto,
        trade_in,
        trade_in_payto,
        reg_cost,
        reg_cost_payto,
        total_cost,
        down_payment,
        down_payment_payto,
        assettype,
        "",
        item_master_id !== "" ? item_master_id : ""
      ).then((response) => {
        if (response.data.success) {
          if (asset_desc !== null) {
            if (item_master_id === "") {
              let asset_id = response.data.id;
              handleCreateItem(asset_id, financed_amt);
            }
          }
          if (contract_term === "Loan") {
            handlefinanced(id);
          } else {
            handleiir(id);
            handlefinanced(id);
          }
        } else {
        }
      });
    }
  };

  const handlefinanced = (id) => {
    let url = API + "contracts/financedamount/" + id + "/";
    axios
      .get(url, { headers: authHeader() })
      .then((response) => console.log("data", response.data));
  };

  const handleiir = (id) => {
    let url = API + "contracts/contractiir/?";
    url += "id=" + id;
    axios
      .get(url, { headers: authHeader() })
      .then((response) => console.log("data", response.data));
  };

  const handleFormKeyDown = async (e) => {
    if (e.key !== "Enter") return;

    // Don't interfere with textarea
    if (e.target.tagName === "TEXTAREA") return;

    e.preventDefault();

    if (currentStep < totalSteps) {
      await handleNextClick(e); // Go to next step
    } else {
      handleSubmit(handleRegister)(); // Create contract only on last step
    }
  };

  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true);
    setDisablebutton(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AddContractService.addContract(
        contract_number,
        selectedValue,
        Helper.DatePicker(start_date),
        contract_term,
        address_id,
        contract_type,
        Helper.DatePicker(end_date),
        deposit_amount,
        feesontime,
        tax_rate_rent,
        tax_rate_fee,
        paymentrule,
        filedcontract,
        Helper.DatePicker(paymentstart_date),
        amount,
        frequency,
        payment_type,
        achPayments,
        achAccount,
        appOriginator,
        source,
        salesRep,
        subcompany,
        lineOfBusiness,
        contractTerms
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
          setContractID(response.data.contractID);
          setTimeout(() => {
            setDisablebutton(false);
            navigate("/editrentalcontract", {
              state: response.data.contractID,
            });
            handlefinanced(response.data.contractID);
            handleiir(response.data.contractID);
          }, 2000);
          setTimeout(() => {
            handleRegisterasset(response.data.contractID);
            handlepaymentscreen(response.data.contractID);
            handlePartyRoleRegister(response.data.contractID);
          }, 1000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          setLoading(false);
          setDisablebutton(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
        }
      });
    }
  };

  const handelClick = () => {
    navigate("/contract");
  };

  const checkBtn3 = useRef();
  const [installaddress_line_1, setInstallAddress_line_1] = useState("");
  const [installaddress_line_2, setInstallAddress_line_2] = useState("");
  const [installcity, setInstallCity] = useState("");
  const [installzip_code, setInstallZip_code] = useState("");
  const [installcountry, setInstallCountry] = useState("");
  const [installbill_to, setInstallBill_to] = useState("Yes");
  const [installship_to, setInstallShip_to] = useState("No");
  const [installinstall_to, setInstallInstall_to] = useState("Yes");

  const [stateaddressId, setStateAddressId] = useState("");
  const [venderstateaddressId, setVenderStateAddressId] = useState("");
  const [install_stateaddressId, setInstall_StateAddressId] = useState("");

  const [selectedVendor, setSelectedVendor] = useState(null);
  const [filteredVendor, setFilterVendor] = useState([]);

  const handleAddressforInstall = () => {
    form3.current.validateAll();
    if (checkBtn3.current.context._errors.length === 0) {
      if (selectedValue === null) {
        confirmAlert({
          title: "",
          message: "Please select customer",
          buttons: [
            {
              label: "OK",
            },
          ],
        });
      } else {
        AddPartyAddressService.addPartyAddress(
          selectedValue,
          installaddress_line_1,
          installaddress_line_2,
          installcity,
          installstateaddress,
          installzip_code,
          installcountry,
          installbill_to,
          installship_to,
          installinstall_to
        ).then((response) => {
          if (response.data.success) {
            setSuccessful(true);

            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setValue("address_id", response.data.addressId, { shouldValidate: true });
            setReg_address1(response.data.addressId);
            setTimeout(() => {
              getinstalladdress(response.data.addressId);
              setState2({ isPaneOpen: false });
            }, 1000);
            setInstallAddress_line_1("");
            setInstallAddress_line_2("");
            setInstallCity("");
            setInstallStateAddress("");
            setInstallZip_code("");
            setInstallCountry("");
          } else {
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          }
        });
      }
    }
  };

  const getcountry = async () => {
    const res = await fetch(API + "helper/ajax/load-countries/");
    const getcon = await res.json();
    setCountry_name(await getcon);
    setVendor_Country_name(await getcon);
    setInstall_Country_name(await getcon);
  };

  const getstate = async () => {
    if (countryid) {
      const resst = await fetch(
        API + "helper/ajax/load-states/" + countryid + "/"
      );
      const getst = await resst.json();
      setState(await getst);
    }
    if (installcountryid) {
      const resst = await fetch(
        API + "helper/ajax/load-states/" + installcountryid + "/"
      );
      const getst = await resst.json();
      setInstall_State(await getst);
    }
    if (vendorcountryid) {
      const resst = await fetch(
        API + "helper/ajax/load-states/" + vendorcountryid + "/"
      );
      const getst = await resst.json();
      setVendor_State(await getst);
    }
  };

  const handlecountry = (event) => {
    const getcoutryId = event.target.value;
    setCountryid(getcoutryId);
    const countryName = country_name.filter(
      (val) => val.id === parseInt(getcoutryId)
    );
    const getcountryName = countryName[0]?.name || null;
    setCountry(getcountryName);
    setValue("country_name", getcountryName,);
  };

  const handlecountryVendor = (event) => {
    const getcoutryId = event.target.value;
    setVendorCountryid(getcoutryId);
    const countryName = country_name.filter(
      (val) => val.id === parseInt(getcoutryId)
    );
    const getcountryName = countryName[0]?.name || null;
    setVendorCountry(getcountryName);
    setValue("vendor_country_name", getcountryName,);
  };
  const handlecountryInstall = (event) => {
    const getcoutryId = event.target.value;
    setInstallCountryid(getcoutryId);
    const countryName = install_country_name.filter(
      (val) => val.id === parseInt(getcoutryId)
    );
    const getcountryName = countryName[0]?.name || null;
    setInstallCountry(getcountryName);
    setValue("install_country_name", getcountryName,);
  };

  const handlestate = (event) => {
    const getstateId = event.target.value;
    setStateAddressId(getstateId);

    const stateName = state_name.filter(
      (val) => val.id === parseInt(getstateId)
    );
    const getstateName = stateName[0]?.name || null;
    setStateAddress(getstateName);
    setValue("state", getstateName,);
  };

  const handlestateVender = (event) => {
    const getstateId = event.target.value;
    setVenderStateAddressId(getstateId);

    const stateName = vendor_state_name.filter(
      (val) => val.id === parseInt(getstateId)
    );
    const getstateName = stateName[0]?.name || null;
    setVendorStateAddress(getstateName);
    setValue("vendorstateaddress", getstateName,);
  };
  const handlestateInstall = (event) => {
    const getstateId = event.target.value;
    setInstall_StateAddressId(getstateId);

    const stateName = install_state_name.filter(
      (val) => val.id === parseInt(getstateId)
    );
    const getstateName = stateName[0]?.name || null;
    setInstallStateAddress(getstateName);
    setValue("install_state_name", getstateName,);
  };

  useEffect(() => {
    if (countryid !== null && countryid !== undefined) {
      getstate();
    }
    if (installcountryid !== null && installcountryid !== undefined) {
      getstate();
    }
    if (vendorcountryid !== null && vendorcountryid !== undefined) {
      getstate();
    }
  }, [countryid, installcountryid, vendorcountryid]);

  useEffect(() => {
    getcountry();
  }, []);

  useEffect(() => {
    if (countryid) {
      const countryName = country_name.filter(
        (val) => val.id === parseInt(countryid)
      );
      const getcountryName = countryName[0]?.name || null;
      setCountry(getcountryName);
      setValue("country_name", getcountryName,);
    }
  }, [countryid, country_name]);

  useEffect(() => {
    if (installcountryid) {
      const countryName = install_country_name.filter(
        (val) => val.id === parseInt(installcountryid)
      );
      const getcountryName = countryName[0]?.name || null;
      setInstallCountry(getcountryName);
      setValue("install_country_name", getcountryName,);
    }
  }, [installcountryid, install_country_name]);

  useEffect(() => {
    if (vendorcountryid) {
      const countryName = vendor_country_name.filter(
        (val) => val.id === parseInt(vendorcountryid)
      );
      const getcountryName = countryName[0]?.name || null;
      setVendorCountry(getcountryName);
      setValue("vendorcountry", getcountryName,);
    }
  }, [vendorcountryid, vendor_country_name]);

  const loadOptionInstallAdd = async (inputValue, callback) => {
    const filteredOptions = reg_address
      .filter((address) =>
        `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`
          .toLowerCase()
          .includes(inputValue.toLowerCase())
      )
      .map((address) => ({
        value: address.id,
        label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`,
      }));

    setFilteredOptions(filteredOptions);
    callback(filteredOptions);
  };

  useEffect(() => {
    const options = reg_address.map((address) => ({
      value: address.id,
      label: `${address.address_line_1}, ${address.address_line_2}, ${address.city}, ${address.state}, ${address.country}`,
    }));
    setFilteredOptions(options);
  }, [customer_name, reg_address, reg_address1]);

  const handleAddressChange = (selectedOption) => {
    if (selectedOption) {
      setReg_address1(selectedOption.value);
      setSelectedAddress(selectedOption.value);
      setValue("address_id", selectedOption.value, { shouldValidate: true });
    } else {
      setReg_address1(null);
      setSelectedAddress(null);
      setValue("address_id", null, { shouldValidate: true });
    }
    trigger("addressid");
  };

  useEffect(() => {
    if (reg_address1 && filteredOptions.find((val) => val.value === reg_address1)) {
      trigger("addressid");
    }
  }, [reg_address1, filteredOptions, trigger]);

  const loadOptionVendorName = async (inputValue, callback) => {
    const filteredOptions = vendor_name
      .filter((val) =>
        val.customer_name.toLowerCase().includes(inputValue.toLowerCase())
      )
      .map((values) => ({
        value: values.id,
        label: values.customer_name,
      }));

    setFilterVendor(filteredOptions);
    callback(filteredOptions);
  };

  useEffect(() => {
    const options = vendor_name.map((val) => ({
      value: val.id,
      label: val.customer_name,
    }));
    setFilterVendor(options);
  }, [vendor_name]);

  const handleVendorChange = (selectedOption) => {
    if (selectedOption) {
      setSelectedVendor(selectedOption.value);
      setVendorName1(selectedOption.value);
      setValue("vendorname1", selectedOption.value, { shouldValidate: true });
    } else {
      setSelectedVendor(null);
      setVendorName1(null);
    }
  };
  const handlePartyAsset = () => {
    setFormData({
      asset_desc: asset_desc,
      asset_number: asset_number,
      make: make,
      manufacturer: manufacturer,
      mileage: milage,
      model: model,
      residulevalue: residal_value,
      vin_number: vin_number,
      year: year,
      in_service_date: in_service_date,
      license_number: license_number,
      license_state: license_state,
    });
    if (form5.current) {
      // setAsset_desc('')
      // setVin_number('')
      // setYear('')
      // setManufacturer('')
      // setMake('')
      // setModel('')
      // setResidal_value(null)
      // setIn_service_date('')
      // setMilage(null)
      reset5({
        asset_desc: asset_desc,
        year: year,
        make: make,
        model: model,
        manufacturer: manufacturer,
      });
      setValue("vehiclecost", vehicle_cost,);
      setTimeout(() => {
        setState3({ isPaneOpen: false });
        setState6({ isPaneOpen: false });
      }, 2000);
    }
  };

  const handlevin = (e) => {
    if (vin_number === "") {
      return false;
    } else {
      let url = `https://vpic.nhtsa.dot.gov/api/vehicles/decodevinvalues/${e.target.value}?format=json`;
      axios.get(url, { headers: authHeader() }).then((response) => {
        // setVinDecode(response.data)
        setMake(response.data.Results[0].Make);
        setModel(response.data.Results[0].Model);
        setManufacturer(response.data.Results[0].Manufacturer);
        setYear(response.data.Results[0].ModelYear);
      });
    }
  };

  const handleAssetType = (value) => {
    setAssetTypeSelection(value);
    setValue("assettype", value,);
  };

  const hanldevehiclecost = (value) => {
    setVehicle_cost(value);
    setValue("vehiclecost", value,);
  };

  const handleDescription = (value) => {
    setAsset_desc(value);
    setValue("asset_desc", value,);
  };

  useEffect(() => {
    setIsEquipment(asset_typeselection === "Equipment");
  }, [asset_typeselection]);

  const addTableRows = () => {
    setTermError("");
    const rowsInput = {
      no_of_payments: "",
      payment_type: "Rent",
      payment_frequency: frequency,
      start_date: "",
      end_date: "",
      amount: null,
    };
    setRowsData([...rowsData, rowsInput]);
  };

  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
    setTermError("");
    // totalInvoiceAmount();
  };

  const handleTermChange = (index, value) => {
    const termMonths = parseInt(value);
    const updatedRowsData = [...rowsData];
    const currentType = updatedRowsData[index].payment_type;
    let startDate = new Date(start_date);
    setTermError("");
    if (currentType === "Rent") {
      setTermError("");
      updatedRowsData[index].no_of_payments = value;
      if (frequency === "Monthly") {
        if (value === "") {
          updatedRowsData[index].start_date = "";
          updatedRowsData[index].end_date = "";
          setTermError("");
        } else if (!isNaN(termMonths) && termMonths >= 0) {
          const currentTotalTerms =
            updatedRowsData.reduce((acc, row, idx) => {
              return idx === index
                ? acc
                : acc +
                (row.payment_type === "Rent"
                  ? parseInt(row.no_of_payments || 0)
                  : 0);
            }, 0) + termMonths;
          if (currentTotalTerms > contract_term) {
            setTermError(`Total term cannot exceed ${contract_term} terms.`);
            setRowsData(updatedRowsData);
            return;
          } else {
            setTermError("");

            if (index === 0) {
              startDate = new Date(start_date);
            } else {
              for (let i = index - 1; i >= 0; i--) {
                if (updatedRowsData[i].payment_type === "Rent") {
                  let date = Helper.Dateview(updatedRowsData[i].end_date);
                  startDate = new Date(date);
                  startDate.setHours(0, 0, 0, 0);
                  startDate.setDate(startDate.getDate() + 1);
                  break;
                }
              }
              if (!startDate) {
                startDate = new Date(start_date);
              }
            }

            const endDate = new Date(startDate);
            endDate.setMonth(endDate.getMonth() + termMonths);
            endDate.setDate(endDate.getDate() - 1);

            updatedRowsData[index].start_date = Helper.DatePicker(startDate);
            updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          }
        }
      } else if (frequency === "Quarterly") {
        const totalTerm = contract_term / frequencyMapped.Quarterly;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Rent"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Rent") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.Quarterly * termMonths;
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Quarterly";
        }
      } else if (frequency === "Semi-annual") {
        const totalTerm = contract_term / frequencyMapped.SemiAnnual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Rent"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Rent") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.SemiAnnual * termMonths;
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Semi-annual";
        }
      } else if (frequency === "Annual") {
        const totalTerm = contract_term / frequencyMapped.Annual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Rent"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Rent") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);

          const month = frequencyMapped.Annual * termMonths;
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Annual";
        }
      }
      setRowsData(updatedRowsData);
    } else if (currentType === "Maintenance Fee") {
      let frequencyData;
      setTermError("");
      updatedRowsData[index].no_of_payments = value;
      frequencyData = updatedRowsData[index].payment_frequency;

      if (frequencyData === "Monthly") {
        if (value === "") {
          updatedRowsData[index].start_date = "";
          updatedRowsData[index].end_date = "";
          setTermError("");
        } else if (!isNaN(termMonths) && termMonths >= 0) {
          const currentTotalTerms =
            updatedRowsData.reduce((acc, row, idx) => {
              return idx === index
                ? acc
                : acc +
                (row.payment_type === "Maintenance Fee"
                  ? parseInt(row.no_of_payments || 0)
                  : 0);
            }, 0) + termMonths;
          if (currentTotalTerms > contract_term) {
            setTermError(`Total term cannot exceed ${contract_term} terms.`);
            setRowsData(updatedRowsData);
            return;
          } else {
            setTermError("");

            if (index === 0) {
              startDate = new Date(start_date);
            } else {
              for (let i = index - 1; i >= 0; i--) {
                if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                  let date = Helper.Dateview(updatedRowsData[i].end_date);
                  startDate = new Date(date);
                  startDate.setHours(0, 0, 0, 0);
                  startDate.setDate(startDate.getDate() + 1);
                  break;
                }
              }
              if (!startDate) {
                startDate = new Date(start_date);
              }
            }

            const endDate = new Date(startDate);
            endDate.setMonth(endDate.getMonth() + termMonths);
            endDate.setDate(endDate.getDate() - 1);
            updatedRowsData[index].payment_frequency = "Monthly";
            updatedRowsData[index].start_date = Helper.DatePicker(startDate);
            updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          }
        }
      } else if (frequencyData === "Quarterly") {
        const totalTerm = contract_term / frequencyMapped.Quarterly;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Maintenance Fee"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.Quarterly * termMonths;
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Quarterly";
        }
      } else if (frequencyData === "Semi-annual") {
        const totalTerm = contract_term / frequencyMapped.SemiAnnual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Maintenance Fee"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);
          const month = frequencyMapped.SemiAnnual * termMonths;
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Semi-annual";
        }
      } else if (frequencyData === "Annual") {
        const totalTerm = contract_term / frequencyMapped.Annual;
        const currentTotalTerms = updatedRowsData.reduce((acc, row) => {
          return (
            acc +
            (row.payment_type === "Maintenance Fee"
              ? parseInt(row.no_of_payments || 0)
              : 0)
          );
        }, 0);
        if (currentTotalTerms > totalTerm) {
          setTermError(`Total term cannot exceed ${totalTerm} terms.`);
          setRowsData(updatedRowsData);
          return;
        } else {
          setTermError("");

          let startDate;
          if (index === 0) {
            startDate = new Date(start_date);
          } else {
            for (let i = index - 1; i >= 0; i--) {
              if (updatedRowsData[i].payment_type === "Maintenance Fee") {
                let date = Helper.Dateview(updatedRowsData[i].end_date);
                startDate = new Date(date);
                startDate.setHours(0, 0, 0, 0);
                startDate.setDate(startDate.getDate() + 1);
                break;
              }
            }
            if (!startDate) {
              startDate = new Date(start_date);
            }
          }

          const endDate = new Date(startDate);

          const month = frequencyMapped.Annual * termMonths;
          endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
          endDate.setDate(endDate.getDate() - 1);
          updatedRowsData[index].start_date = Helper.DatePicker(startDate);
          updatedRowsData[index].end_date = Helper.DatePicker(endDate);
          updatedRowsData[index].payment_frequency = "Annual";
        }
      }
      setRowsData(updatedRowsData);
    }
  };

  const handelChangeAmount = (index, event) => {
    setTermError("");
    const updatedRowsData = [...rowsData];
    updatedRowsData[index].amount = event;

    setRowsData(updatedRowsData);
  };

  const handlePayment = () => {
    const term = rowsData.map((val) => val.no_of_payments);
    const amount = rowsData.map((val) => val.amount);

    setTermError("");

    let contractTerm = null;
    if (frequency === "Monthly") {
      contractTerm = contract_term / frequencyMapped.Monthly;
    } else if (frequency === "Quarterly") {
      contractTerm = contract_term / frequencyMapped.Quarterly;
    } else if (frequency === "Semi-annual") {
      contractTerm = contract_term / frequencyMapped.SemiAnnual;
    } else if (frequency === "Annual") {
      contractTerm = contract_term / frequencyMapped.Annual;
    }
    const totalPayments = rowsData.reduce((sum, row) => {
      const payments = parseInt(row.no_of_payments, 10);
      return row.payment_type === "Rent"
        ? sum + (isNaN(payments) ? 0 : payments)
        : sum;
    }, 0);

    let rowContractTerm = null;
    const totalPaymentsMaintentence = rowsData.reduce((sum, row) => {
      const payments = parseInt(row.no_of_payments, 10);

      if (row.payment_type === "Maintenance Fee") {
        if (row.payment_frequency === "Monthly") {
          rowContractTerm = contract_term / frequencyMapped.Monthly;
        } else if (row.payment_frequency === "Quarterly") {
          rowContractTerm = contract_term / frequencyMapped.Quarterly;
        } else if (row.payment_frequency === "Semi-annual") {
          rowContractTerm = contract_term / frequencyMapped.SemiAnnual;
        } else if (row.payment_frequency === "Annual") {
          rowContractTerm = contract_term / frequencyMapped.Annual;
        }
      }

      return row.payment_type === "Maintenance Fee"
        ? sum + (isNaN(payments) ? 0 : payments)
        : sum;
    }, 0);

    if (term.includes("") || term.includes(0)) {
      setTermError("No of payment is required");
      return;
    }
    if (amount.includes("") || amount.includes(null)) {
      setTermError("Amount is required");
      return;
    }

    const negativeAmount = amount.some((a) => parseFloat(a) < 0);
    if (negativeAmount) {
      setTermError("Only positive numbers are allowed");
      return;
    }

    if (totalPayments !== contractTerm) {
      setTermError(`Total number of Rent term ${contractTerm} is required`);
      return;
    }

    if (totalPaymentsMaintentence > rowContractTerm) {
      setTermError(
        `Total number of Maintenance term ${rowContractTerm} is required`
      );
      return;
    }

    if (!termError) {
      setTimeout(() => {
        setState5({ isPaneOpen: false });
      }, 1000);
    } else {
      setRowsData([...rowsData]);
    }
  };

  useEffect(() => {
    if (
      amount !== null &&
      amount > 0 &&
      amount !== undefined &&
      contract_term !== ""
    ) {
      let contractTerm = null;
      let startDate;
      let endDate;
      if (frequency === "Monthly") {
        contractTerm = contract_term / frequencyMapped.Monthly;
        startDate = new Date(start_date);
        endDate = new Date(startDate);
        endDate.setMonth(endDate.getMonth() + contractTerm);
        endDate.setDate(endDate.getDate() - 1);
      } else if (frequency === "Quarterly") {
        contractTerm = contract_term / frequencyMapped.Quarterly;
        startDate = new Date(start_date);
        endDate = new Date(startDate);
        const month = frequencyMapped.Quarterly * contractTerm;
        endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
        endDate.setDate(endDate.getDate() - 1);
      } else if (frequency === "Semi-annual") {
        contractTerm = contract_term / frequencyMapped.SemiAnnual;
        startDate = new Date(start_date);
        endDate = new Date(startDate);
        const month = frequencyMapped.SemiAnnual * contractTerm;
        endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
        endDate.setDate(endDate.getDate() - 1);
      } else if (frequency === "Annual") {
        contractTerm = contract_term / frequencyMapped.Annual;
        startDate = new Date(start_date);
        endDate = new Date(startDate);
        const month = frequencyMapped.Annual * contractTerm;
        endDate.setMonth(endDate.getMonth() + month); // Set to the last day of the quarter
        endDate.setDate(endDate.getDate() - 1);
      }
      const rowsInput = {
        no_of_payments: contractTerm,
        payment_type: "Rent",
        start_date: Helper.DatePicker(startDate),
        end_date: Helper.DatePicker(endDate),
        amount: amount,
      };
      setRowsData([rowsInput]);
    } else {
      setRowsData([]);
    }
  }, [amount, frequency, contract_term, frequencyMapped, start_date]);

  const isDisabled = rowsData.length > 1;

  const handlePaymentTypeChange = (index, event) => {
    const updatedRowsData = [...rowsData];
    updatedRowsData[index].payment_frequency = frequency;
    const isOneTimeFee = paymentType.some(pt => pt.value === event && pt.fee_nature === 'One Time');

    if (isOneTimeFee) {
      const paymentTypeExists = updatedRowsData.some(
        (row, idx) => row.payment_type === event && idx !== index
      );

      if (paymentTypeExists) {
        setTermError(`${event} can only have one entry.`);
        return;
      }
    }

    updatedRowsData[index].payment_type = event;

    if (isOneTimeFee) {
      const contractTerm = contract_term / frequencyMapped.Annual;
      let startDate = new Date(start_date);
      let endDate = new Date(startDate);
      // const month = frequencyMapped.Annual * contractTerm;
      if (frequency === "Monthly") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Monthly);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = "Monthly";
      } else if (frequency === "Quarterly") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Quarterly);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = "Quarterly";
      } else if (frequency === "Semi-annual") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.SemiAnnual);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = "Semi-annual";
      } else if (frequency === "Annual") {
        endDate.setMonth(endDate.getMonth() + frequencyMapped.Annual);
        endDate.setDate(endDate.getDate() - 1);
        updatedRowsData[index].no_of_payments = 1;
        updatedRowsData[index].start_date = Helper.DatePicker(startDate);
        updatedRowsData[index].end_date = Helper.DatePicker(endDate);
        updatedRowsData[index].payment_frequency = "Annual";
      }
    } else if (event === "Rent") {
      updatedRowsData[index].payment_frequency = frequency;
    }

    setRowsData(updatedRowsData);
  };

  const handlePaymentFrequencyChange = (index, selectedValue) => {
    let updatedRowsData = [...rowsData];
    updatedRowsData[index].no_of_payments = "";
    let startDate = new Date(start_date);
    let paymentstartDate;
    if (paymentrule === "Advance") {
      paymentstartDate = new Date(start_date);
    } else {
      paymentstartDate = new Date(paymentstart_date);
    }
    if (updatedRowsData[index].payment_type === "Maintenance Fee") {
      let contractTerm = null;
      if (selectedValue === "Monthly") {
        contractTerm = contract_term / frequencyMapped.Monthly;
      } else if (selectedValue === "Quarterly") {
        contractTerm = contract_term / frequencyMapped.Quarterly;
      } else if (selectedValue === "Semi-annual") {
        contractTerm = contract_term / frequencyMapped.SemiAnnual;
      } else if (selectedValue === "Annual") {
        contractTerm = contract_term / frequencyMapped.Annual;
      }
      updatedRowsData[index].no_of_payments = "";
      updatedRowsData[index].start_date = Helper.DatePicker(startDate);
      updatedRowsData[index].payment_frequency = selectedValue;
      updatedRowsData[index].paymentstart_date =
        Helper.DatePicker(paymentstartDate);
      updatedRowsData[index].end_date = "";
      const totalPaymentsMaintentence = rowsData.reduce((sum, row) => {
        const payments = parseInt(row.no_of_payments, 10);
        return row.payment_type === "Maintenance Fee"
          ? sum + (isNaN(payments) ? 0 : payments)
          : sum;
      }, 0);
      if (totalPaymentsMaintentence > contractTerm) {
        setTermError(
          `Total number of Maintenance term ${contractTerm} is required`
        );
        return;
      }
    } else {
      const isOneTimeFee = paymentType.some(
        (pt) => pt.value === updatedRowsData[index].payment_type && pt.fee_nature === "One Time"
      );
      updatedRowsData[index].payment_frequency = selectedValue;
      if (isOneTimeFee) {
        const feeStartDate = new Date(start_date);
        const feeEndDate = new Date(feeStartDate);
        let monthsToAdd = 1;
        if (selectedValue === "Quarterly") monthsToAdd = frequencyMapped.Quarterly;
        else if (selectedValue === "Semi-annual") monthsToAdd = frequencyMapped.SemiAnnual;
        else if (selectedValue === "Annual") monthsToAdd = frequencyMapped.Annual;
        feeEndDate.setMonth(feeEndDate.getMonth() + monthsToAdd);
        feeEndDate.setDate(feeEndDate.getDate() - 1);
        updatedRowsData[index].start_date = Helper.DatePicker(feeStartDate);
        updatedRowsData[index].end_date = Helper.DatePicker(feeEndDate);
        updatedRowsData[index].paymentstart_date = Helper.DatePicker(feeStartDate);
      }
    }
    setRowsData(updatedRowsData);
  };
  // const FeeDefination = () => {
  //   let url =
  //     API +
  //     "contracts/feedefination-view/?feename=Payment Schedule&&active=Yes";
  //   axios.get(url, { headers: authHeader() }).then((response) => {
  //     setPaymentType(response.data);
  //   });
  // };
  const FeeDefination = () => {
    let url = API + "expenses/fee-types/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setPaymentType(response.data);
    });
  };
  useEffect(() => {
    FeeDefination();
  }, []);

  const [state6, setState6] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  const [itemSelect, setItemSelect] = useState("");

  const [valueItem, setValueItem] = useState("");
  const [valueNumber, setValueNumber] = useState();
  const [selectSerial, setSelectSerial] = useState("");

  const [selectModel, setselectModel] = useState("");
  const [valueModel, setValueModel] = useState("");

  const [selectMake, setselectMake] = useState("");
  const [valueMake, setValueMake] = useState("");

  const [selectManu, setselectManu] = useState("");
  const [valueManu, setValueManu] = useState("");

  const [item_master_id, setItem_master_id] = useState("");

  const [inventory_option, setInventory_option] = useState([]);
  const loadOptionItem = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API + `contracts/itemmaster/filter/?itemname=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const handelInputChangeItem = (value) => {
    setValueItem(value);
  };

  const handelChangeItem = (value) => {
    setItemSelect(value);
  };

  const loadOptionsserial = async (inputValue2) => {
    if (inputValue2 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?serialnumber=${inputValue2}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };
  const handelChangeserial = (value1) => {
    setSelectSerial(value1);
  };
  const handelInputChangeSerial = (value1) => {
    setValueNumber(value1);
  };

  const handelChangemodel = (value1) => {
    setselectModel(value1);
  };

  const handelInputChangeModel = (value1) => {
    setValueModel(value1);
  };

  const handelChangeMake = (value1) => {
    setselectMake(value1);
  };

  const loadOptionsMake = async (inputValue4) => {
    if (inputValue4 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?make=${inputValue4}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const handelInputChangeMake = (value1) => {
    setValueMake(value1);
  };

  const loadOptionsModel = async (inputValue3) => {
    if (inputValue3 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?model=${inputValue3}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const handelChangeManu = (value1) => {
    setselectManu(value1);
  };

  const loadOptionsManu = async (inputValue6) => {
    if (inputValue6 !== "") {
      const response = await axios.get(
        API + `contracts/itemmaster/filter/?manufacturer=${inputValue6}`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };
  const handelInputChangeManu = (value1) => {
    setValueManu(value1);
  };

  const handleClear = () => {
    setItemSelect("");
    setSelectSerial("");
    setselectModel("");
    setselectMake("");
    setselectManu("");
    setAsset_desc("");
    setItem_master_id(null);
    setYear("");
    setMake("");
    setModel("");
    setManufacturer("");
    setInventory_option([]);
    setVehicle_cost(0);
    reset5({
      asset_desc: "",
      year: "",
      make: "",
      model: "",
      manufacturer: "",
    });
    setState3({ isPaneOpen: false });
    setState6({ isPaneOpen: false });
  };

  const handelSearch = () => {
    let item_type = "";
    if (asset_type.length === 1) {
      item_type = asset_typesetting;
    } else {
      item_type = asset_typeselection;
    }
    axios
      .get(
        `${API}contracts/search/itemmaster/?description=${asset_desc ? asset_desc : ""
        }&contract_type=${contract_type}&item_type=${item_type}&itemname=${itemSelect ? itemSelect.itemname : ""
        }&serialnumber=${selectSerial ? selectSerial.serialnumber : ""}&model=${selectModel ? selectModel.model : ""
        }&make=${selectMake ? selectMake.make : ""}&manufacturer=${selectManu ? selectManu.manufacturer : ""
        }`,
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        const optionsList = res.data.map((val) => val);
        setInventory_option(optionsList);
        setState3({ isPaneOpen: true });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    let item_type = "";
    if (asset_type.length === 1) {
      item_type = asset_typesetting;
    } else {
      item_type = asset_typeselection;
    }
    axios
      .get(
        `${API}contracts/search/itemmaster/?description=${asset_desc ? asset_desc : ""
        }&contract_type=${contract_type}&item_type=${item_type}&itemname=${itemSelect ? itemSelect.itemname : ""
        }&serialnumber=${selectSerial ? selectSerial.serialnumber : ""}&model=${selectModel ? selectModel.model : ""
        }&make=${selectMake ? selectMake.make : ""}&manufacturer=${selectManu ? selectManu.manufacturer : ""
        }`,
        {
          headers: authHeader(),
        }
      )
      .then((res) => {
        const optionsList = res.data.map((val) => val);
        setInventory_option(optionsList);
        // setState3({ isPaneOpen: true });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [asset_typeselection, asset_typesetting, state6]);

  const handleTagClick = (tag) => {
    setItem_master_id(tag.id);

    setState3({ isPaneOpen: true });
    setState6({ isPaneOpen: false });
  };
  useEffect(() => {
    if (item_master_id) {
      EditItemMasterService.getItemmaster(item_master_id).then((response) => {
        setAsset_desc(response.data.description);
        setYear(response.data.yearofmanufacture);
        setMake(response.data.make);
        setModel(response.data.model);
        setManufacturer(response.data.manufacturer);
        setVehicle_cost(response.data.netbookvalue);

        setLoading(false);
      });
    }
  }, [item_master_id]);

  useEffect(() => {
    reset5({
      asset_desc: asset_desc,
    });
  }, [asset_desc]);

  const handelCancelClick = () => {
    navigate("/contract");
  };

  const [formDataParty, setFormDataParty] = useState({
    party: "",
    role: "",
    contract: "",
  });

  // const handlePartyRoleRegister = (contract_id) => {
  // form.current.validateAll();

  // if (checkBtn.current.context._errors.length === 0) {

  // formDataParty.party = selectedParty
  // formDataParty.role = role
  // formDataParty.contract = contract_id

  // axios
  //     .post(`${API}contracts/party-roles/create/`, formDataParty, { headers: authHeader() })
  //     .then((response) => {
  // if (response.data.success === 1) {
  //     toast.success("Party Role added successfully", {
  //         position: "top-right",
  //         autoClose: 1000,
  //         hideProgressBar: false,
  //         pauseOnHover: true,
  //         draggable: true,
  //         theme: "light",
  //     });
  // setTimeout(() => {
  //     setHideShow(true); // Navigate back to the list
  // }, 1000);
  // } else {
  //     toast.error(response.data.error || "Failed to add Party Role", {
  //         position: "top-right",
  //         autoClose: 1000,
  //         hideProgressBar: false,
  //         pauseOnHover: true,
  //         draggable: true,
  //         theme: "light",
  //     });
  // }
  // })
  // .catch((error) => {
  //     toast.error("Error adding Party Role", {
  //         position: "top-right",
  //         autoClose: 1000,
  //         hideProgressBar: false,
  //         pauseOnHover: true,
  //         draggable: true,
  //         theme: "light",
  //     });
  // });
  // }
  // };



  // const [selectedParty, setselectedParty] = useState(null);
  const [selectedParty, setSelectedParty] = useState(null);

  const [inputpartyvalue, setValueparty] = useState("");
  // const [partyoptions, setPartyOptions] = useState([]);
  const [partyOptions, setPartyOptions] = useState([]);

  const [role, setRole] = useState("");
  const [rolesList, setRolesList] = useState([]);
  const [valueParty, setValueParty] = useState("");

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await axios.get(`${API}company/companysettingsview/`, { headers: authHeader() });
        if (response.data.party_roles) {
          const roles = response.data.party_roles.split(',').map(r => r.trim());
          setRolesList(roles);
        }
      } catch (error) {
        console.error("Error fetching company settings:", error);
        toast.error("Failed to load party roles");
      }
    };
    fetchRoles();
  }, []);


  // const handelInputChangeparty = (value) => {
  //     setValueparty(value);
  //   };

  //   const handelChangeparty = (value) => {
  //     if (value === null) {
  //       setselectedParty(value);
  //       reset({
  //         selectedParty: value,
  //       });

  //     } else {
  //       setselectedParty(value.id);
  //       reset({
  //         selectedParty: value.id,
  //       });

  //     }
  //     trigger("selectedParty");

  //   };

  // const loadOptionsparty = async (inputValue) => {
  //   if (inputValue !== "") {
  //     const responseJSON = await axios.get(
  //       API +
  //       `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
  //       { headers: authHeader() }
  //     );
  //     return responseJSON.data.data;
  //   }
  // };

  //   const loadInitialOptionspartyRole = async () => {
  //           const responseJSON = await axios.get(
  //             API +
  //             `parties/vendor/?party_type=Customer&&customer_name=`,
  //             { headers: authHeader() }
  //           );
  //           setPartyOptions(responseJSON.data.data);
  //         };

  const loadOptionsparty = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API +
        `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const loadInitialOptionspartyRole = async () => {
    const responseJSON = await axios.get(
      API + `parties/vendor/?party_type=Customer&&customer_name=`,
      { headers: authHeader() }
    );
    setPartyOptions(responseJSON.data.data);
  };

  useEffect(() => {

    // loadInitialOptionspartyRole();
    loadInitialOptionspartyRole();

  }, []);

  // Add party role to local state
  const addPartyRole = () => {
    if (selectedParty && role) {
      setPartyRoles([...partyRoles, { partyId: selectedParty.id, partyName: selectedParty.customer_name, role, comment: comment || "" }]);
      setSelectedParty(null);
      setRole('');
      setComment('');
      setValue("selectedParty", null);
    } else {
      toast.error("Please select both party and role");
    }
  };

  // Delete party role from local state
  const deletePartyRole = (index) => {
    const updated = partyRoles.filter((_, i) => i !== index);
    setPartyRoles(updated);
  };

  const handelInputChangeparty = (value) => {
    setValueParty(value);
  };

  const handelChangeparty = (value) => {
    setSelectedParty(value);
    setValue("selectedParty", value ? value.id : null);
  };

  const [partyRoles, setPartyRoles] = useState([]);

  // Modified handlePartyRoleRegister to use party_role_create endpoint
  const handlePartyRoleRegister = async (contractID) => {
    for (const pr of partyRoles) {
      try {
        await axios.post(
          `${API}contracts/party-roles/create/`,
          { party: pr.partyId, contract: contractID, role: pr.role, comment: pr.comment },
          { headers: authHeader() }
        );
        toast.success(`Party role ${pr.role} added successfully`);
      } catch (error) {
        console.error("Error adding party role:", error);
        toast.error("Failed to add party role");
      }
    }
  };


  const [termsList, setTermsList] = useState([]); // API data
  const [selectedTermName, setSelectedTermName] = useState("");
  const [selectedTermValue, setSelectedTermValue] = useState("");
  const [contractTerms, setContractTerms] = useState([]);


  const fetchTerms = async () => {
    try {
      const res = await axios.get(
        `${API}company/term-conditions/`,
        { headers: authHeader() }
      );
      setTermsList(res.data);
    } catch {
      toast.error("Failed to load terms");
    }
  };

  useEffect(() => {
    fetchTerms();
  }, []);

  const handleTermsChange = (name) => {
    setSelectedTermName(name);

    const term = termsList.find((t) => t.name === name);
    setSelectedTermValue(term?.value || "");
  };

  const addTerm = () => {
    if (!selectedTermName) {
      toast.error("Please select term");
      return;
    }

    const newTerm = {
      name: selectedTermName,
      value: selectedTermValue,
    };

    setContractTerms([...contractTerms, newTerm]);

    // reset
    setSelectedTermName("");
    setSelectedTermValue("");
  };

  const deleteTerm = (index) => {
    const updated = [...contractTerms];
    updated.splice(index, 1);
    setContractTerms(updated);
  };


  return (
    <div className="contract-form-container">
      <div className="row g-4">
        <ToastContainer />
        <AddVendor
          state4={state4}
          setState4={setState4}
          handleSubmit4={handleSubmit4}
          handlepartyvendor={handlepartyvendor}
          form4={form4}
          party_typevendor={party_typevendor}
          setParty_typeVendor={setParty_typeVendor}
          customer_typevendor={customer_typevendor}
          register4={register4}
          handleshowhidevendor={handleshowhidevendor}
          errors4={errors4}
          customer_namevendor={customer_namevendor}
          setCustomer_nameVendor={setCustomer_nameVendor}
          vendoraddress_line_1={vendoraddress_line_1}
          setVendorAddress_line_1={setVendorAddress_line_1}
          setVendorAddress_line_2={setVendorAddress_line_2}
          vendoraddress_line_2={vendoraddress_line_2}
          vendorcountryid={vendorcountryid}
          handlecountryVendor={handlecountryVendor}
          vendor_country_name={vendor_country_name}
          venderstateaddressId={venderstateaddressId}
          handlestateVender={handlestateVender}
          vendor_state_name={vendor_state_name}
          vendorcity={vendorcity}
          setVendorCity={setVendorCity}
          vendorzip_code={vendorzip_code}
          setVendorZip_code={setVendorZip_code}
          checkBtn4={checkBtn4}
        />
        <CreateAddress
          state2={state2}
          setState2={setState2}
          handleSubmit3={handleSubmit3}
          handleAddressforInstall={handleAddressforInstall}
          form3={form3}
          installaddress_line_1={installaddress_line_1}
          register3={register3}
          setInstallAddress_line_1={setInstallAddress_line_1}
          errors3={errors3}
          setInstallAddress_line_2={setInstallAddress_line_2}
          installaddress_line_2={installaddress_line_2}
          installcountryid={installcountryid}
          handlecountryInstall={handlecountryInstall}
          country_name={country_name}
          install_stateaddressId={install_stateaddressId}
          handlestateInstall={handlestateInstall}
          install_state_name={install_state_name}
          installcity={installcity}
          setInstallCity={setInstallCity}
          installzip_code={installzip_code}
          setInstallZip_code={setInstallZip_code}
          checkBtn3={checkBtn3}
        />
        <AddCutomer
          state1={state1}
          setState1={setState1}
          handleSubmit2={handleSubmit2}
          party_type={party_type}
          handlepartydefault={handlepartydefault}
          setParty_type={setParty_type}
          form2={form2}
          customer_type={customer_type}
          register2={register2}
          handleshowhide={handleshowhide}
          errors2={errors2}
          customer_name={customer_name}
          setCustomer_name={setCustomer_name}
          address_line_1={address_line_1}
          setAddress_line_1={setAddress_line_1}
          countryid={countryid}
          country_name={country_name}
          handlecountry={handlecountry}
          stateaddressId={stateaddressId}
          state_name={state_name}
          handlestate={handlestate}
          city={city}
          setCity={setCity}
          zip_code={zip_code}
          setZip_code={setZip_code}
          checkBtn2={checkBtn2}
          setAddress_line_2={setAddress_line_2}
          address_line_2={address_line_2}
        />
        <FilterAsset
          state6={state6}
          setState6={setState6}
          itemSelect={itemSelect}
          loadOptionItem={loadOptionItem}
          handelInputChangeItem={handelInputChangeItem}
          handelChangeItem={handelChangeItem}
          selectSerial={selectSerial}
          loadOptionsserial={loadOptionsserial}
          handelInputChangeSerial={handelInputChangeSerial}
          handelChangeserial={handelChangeserial}
          selectModel={selectModel}
          loadOptionsModel={loadOptionsModel}
          handelInputChangeModel={handelInputChangeModel}
          handelChangemodel={handelChangemodel}
          selectMake={selectMake}
          loadOptionsMake={loadOptionsMake}
          handelInputChangeMake={handelInputChangeMake}
          handelChangeMake={handelChangeMake}
          selectManu={selectManu}
          loadOptionsManu={loadOptionsManu}
          handelInputChangeManu={handelInputChangeManu}
          handelChangeManu={handelChangeManu}
          handleClear={handleClear}
          handelSearch={handelSearch}
          item_master_id={item_master_id}
          handleTagClick={handleTagClick}
          inventory_option={inventory_option}
        />
        <AddAsset
          state3={state3}
          setState3={setState3}
          isEquipment={isEquipment}
          handleSubmit5={handleSubmit5}
          handlePartyAsset={handlePartyAsset}
          form5={form5}
          asset_number={asset_number}
          register5={register5}
          setAsset_number={setAsset_number}
          make={make}
          setMake={setMake}
          model={model}
          setModel={setModel}
          manufacturer={manufacturer}
          setManufacturer={setManufacturer}
          residal_value={residal_value}
          setResidal_value={setResidal_value}
          in_service_date={in_service_date}
          setIn_service_date={setIn_service_date}
          checkBtn5={checkBtn5}
          handlevin={handlevin}
          vin_number={vin_number}
          setVin_number={setVin_number}
          year={year}
          setYear={setYear}
          milage={milage}
          setMilage={setMilage}
        />
        <AddPayment
          state5={state5}
          setState5={setState5}
          setRowsData={setRowsData}
          setTermError={setTermError}
          form6={form6}
          handleSubmit6={handleSubmit6}
          handlePayment={handlePayment}
          addTableRows={addTableRows}
          rowsData={rowsData}
          handlePaymentTypeChange={handlePaymentTypeChange}
          paymentType={paymentType}
          handelChangeAmount={handelChangeAmount}
          errors={errors}
          handlePaymentFrequencyChange={handlePaymentFrequencyChange}
          paymentFrequency={paymentFrequency}
          handleTermChange={handleTermChange}
          deleteTableRows={deleteTableRows}
          termError={termError}
          checkBtn6={checkBtn6}
        />
        <div className="col-lg-8 col-md-12">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-white border-bottom-0 py-3">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">{t("Create Contract Rental")}</h5>
                <span className="badge bg-light text-dark">
                  Step {currentStep} of {totalSteps}
                </span>
              </div>
              <div className="progress mt-3" style={{ height: "4px" }}>
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: `${(currentStep / totalSteps) * 100}%` }}
                  aria-valuenow={currentStep}
                  aria-valuemin="0"
                  aria-valuemax={totalSteps}
                ></div>
              </div>
            </div>
            <div className="card-body py-4">
              {/* <Form
                role="form text-left"
                onSubmit={handleSubmit(handleRegister)}
                ref={form}
                action="."
                method="POST"
                id="addPartyForm"
                className="contract-form-body"
              > */}
              <Form
                role="form"
                onSubmit={(e) => {
                  // Prevent normal submit on steps 1-4
                  if (currentStep < totalSteps) {
                    e.preventDefault();
                    return;
                  }

                  handleSubmit(handleRegister)(e);
                }}
                onKeyDown={handleFormKeyDown}
                ref={form}
                action="."
                method="POST"
                id="addPartyForm"
              >
                {currentStep === 1 && (
                  <div className="form-section">
                    <h2 className="section-title">{t("Basic Information")}</h2>

                    <div className="row mb-4">
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Sub Company")}{" "}
                          <Tooltip content={t("Subcompany_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <select
                          className="form-select"
                          // value={subcompany}
                          name="subcompany"
                          // onChange={(e) => {
                          //   setSubcompany(e.target.value);
                          //   setValue("subcompany", e.target.value);
                          // }}
                          {...register("subcompany", {
                            onChange: (e) => {
                              setSubcompany(e.target.value);
                              setValue("subcompany", e.target.value);
                            },
                            required: false,
                          })}
                        >
                          <option value="">Select Subcompany</option>
                          {subcompanyOptions.map((sub) => (
                            <option key={sub.id} value={sub.id}>
                              {sub.sub_company_name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Line of Business")}{" "}
                          <Tooltip content={t("Lineofbusiness_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <select
                          className="form-select"
                          // value={lineOfBusiness}
                          name="lineOfBusiness"
                          {...register("lineOfBusiness", {
                            onChange: (e) => {
                              setLineOfBusiness(e.target.value);
                              setValue("lineOfBusiness", e.target.value);
                            },
                            required: false,
                          })}
                        >
                          <option value="">Select Line of Business</option>
                          {lineOfBusinessOptions.map((lob) => (
                            <option key={lob.id} value={lob.id}>
                              {lob.lob_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-6 mb-3 mb-md-0">
                        <label className="col-form-label required">
                          {t("Contract Number")}{" "}
                          <Tooltip content={t("Contract_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          disabled={
                            contract_number_method_disable === "Automatic"
                              ? true
                              : false
                          }
                          onChange={(e) => setContract_number(e.target.value)}
                          type="text"
                          className='form-control'
                          name="contract_number"
                          id="contract_number"
                          {...register("contract_number", {
                            onChange: (e) => {
                              setContract_number(e.target.value);
                            },
                            required:
                              contract_number_method_disable === "Automatic"
                                ? false
                                // : true,
                                : "Contract number is required",
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.contract_number && errors.contract_number.message}
                        </div>
                      </div>
                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <label className="col-form-label required">
                          {t("Customer")}{" "}
                          <Tooltip content={t("Customer_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        {/* <div className="input-group"> */}
                        <div className="col-lg-12">
                          <AsyncSelect
                            {...register("selectedValue", {
                              required: "Customer is required",
                            })}
                            defaultOptions={options}
                            isClearable
                            placeholder={t("Search for Customer(%for All)")}
                            options={options}
                            value={options.find(
                              (option) => option.id === selectedValue
                            )}
                            getOptionLabel={(e) => e.customer_name}
                            getOptionValue={(e) => e.customer_name}
                            loadOptions={loadOptions}
                            onInputChange={handelInputChange}
                            onChange={handelChange}
                            name="selectedValue"
                          ></AsyncSelect>
                          <div className="invalid-feedback">
                            {errors.selectedValue &&
                              errors.selectedValue.message}
                          </div>
                        </div>
                        <button
                          type="button"
                          className="btn-link add-new-link"
                          // onClick={() => setState1({ isPaneOpen: true })}
                          onClick={() => { setAddCustomerSource('step1'); setState1({ isPaneOpen: true }); }}
                        >
                          <Plus className="btn-icon-small" />
                          Add New Customer
                        </button>
                      </div>
                    </div>
                    <div className="row mb-4">
                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <label className="col-form-label required">
                          {t("Bill to Address")}{" "}
                          <Tooltip content={t("BilltoAddress_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <AsyncSelect
                            {...register("billto", {
                              required: "Address is required",
                            })}
                            name="billto"
                            cacheOptions
                            defaultOptions={filterBill}
                            isClearable
                            isSearchable
                            options={filterBill}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            onChange={handleBillAddressChange}
                            loadOptions={loadOptionBillAdd}
                            value={filterBill.find(
                              (val) => val.value === address_id
                            )}
                            placeholder={`${t("Search Address")}`}
                          />
                          <div className="invalid-feedback">
                            {!address_id &&
                              errors.billto &&
                              errors.billto.message}
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                        <label className="col-form-label required">
                          {t("Installed Location")}{" "}
                          <Tooltip content={t("InstallAddress_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <AsyncSelect
                            {...register("address_id", {
                              required: "Install Address is required",
                            })}
                            name="address_id"
                            cacheOptions
                            defaultOptions={filteredOptions}
                            isClearable
                            isSearchable
                            options={filteredOptions}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            onChange={handleAddressChange}
                            loadOptions={loadOptionInstallAdd}
                            value={filteredOptions.find(
                              (val) => val.value === reg_address1
                            )}
                            placeholder={`${t("Search Install Address")}`}
                          />
                          <div className="invalid-feedback">
                            {!reg_address1 &&
                              errors.address_id &&
                              errors.address_id.message}
                          </div>
                        </div>
                        <button
                          type="button"
                          className="btn-link add-new-link"
                          onClick={() => setState2({ isPaneOpen: true })}
                        >
                          <Plus className="btn-icon-small" />
                          Add New Location
                        </button>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3 mb-md-0">
                        <label className="col-form-label required">
                          {t("Start Date")}{" "}
                          <Tooltip content={t("StartDate_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="col-lg-12">
                          <DatePicker
                            {...register("startdate", { required: true })}
                            className="form-control datepick"
                            selected={start_date}
                            onChange={(e) => handelStart_Date(e)}
                            name="startdate"
                            placeholderText={"mm/dd/yyyy"}
                            showYearDropdown // year show and scrolldown alos
                            scrollableYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                          />
                          <div className="invalid-feedback">
                            {errors.startdate && "Start Date  is required"}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Term")}{" "}
                          <Tooltip content={t("Term_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="contract_term"
                          id="contract_term"
                          {...register("contract_term", {
                            required: "Term is required",
                            max: {
                              value:
                                free.length !== 0 ? free[0].contract_term : 60,
                              // message: `Term should not be more than ${free.length !== 0 ? free[0].contract_term : 60} for this user plan`,
                              message: `Maximum term is 60 months. Please enter a term between 1 and 60.`,
                            },
                            validate: {
                              positiveWholeNumber: (value) => {
                                const numberValue = Number(value);
                                if (isNaN(numberValue)) {
                                  return "Only numbers are allowed";
                                } else if (numberValue % 1 !== 0) {
                                  return "Decimal numbers are not allowed";
                                } else if (
                                  !Number.isInteger(numberValue) ||
                                  numberValue <= 0
                                ) {
                                  return "Only positive numbers are allowed";
                                }
                                return true;
                              },
                            },
                            onChange: (e) => {
                              handelContract_term(e.target.value);
                            },
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.contract_term && errors.contract_term.message}
                        </div>
                      </div>
                      {/* <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Application Originator")}{" "}
                          <Tooltip content={t("ApplicationOrginator_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={appOriginator}
                          name="appOriginator"
                          placeholder="Enter Application Originator"
                          {...register("appOriginator", {
                            onChange: (e) => {
                              setAppOriginator(e.target.value);
                              setValue("appOriginator", e.target.value);
                            },
                            required: false,
                          })}
                        />
                        {errors.appOriginator && (
                          <div className="text-danger">
                            {errors.appOriginator.message}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Source")}{" "}
                          <Tooltip content={t("Source_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={source}
                          name="source"
                          placeholder="Enter Source"
                          {...register("source", {
                            onChange: (e) => {
                              setSource(e.target.value);
                              setValue("source", e.target.value);
                            },
                            required: false,
                          })}
                        />
                        {errors.source && (
                          <div className="text-danger">
                            {errors.source.message}
                          </div>
                        )}
                      </div> */}
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Sales Representative")}{" "}
                          <Tooltip content={t("SalesRep_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          value={salesRep}
                          name="salesRep"
                          placeholder="Enter Sales Representative"
                          {...register("salesRep", {
                            onChange: (e) => {
                              setSalesRep(e.target.value);
                              setValue("salesRep", e.target.value);
                            },
                            required: false,
                          })}
                        />
                        {errors.salesRep && (
                          <div className="text-danger">
                            {errors.salesRep.message}
                          </div>
                        )}
                      </div>

                    </div>
                  </div>
                )}

                {currentStep === 2 && (
                  <div className="form-section">
                    <h2 className="section-title">Asset Details</h2>

                    <div className="row mb-4">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Vendor Name")}{" "}
                          <Tooltip content={t("VendorName_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <AsyncSelect
                          {...register("vendorname1", {
                            required: "Vendor is required",
                          })}
                          name="vendorname1"
                          cacheOptions
                          defaultOptions={filteredVendor}
                          isClearable
                          isSearchable
                          options={filteredVendor}
                          getOptionLabel={(option) => option.label}
                          getOptionValue={(option) => option.value}
                          onChange={handleVendorChange}
                          loadOptions={loadOptionVendorName}
                          value={filteredVendor.find(
                            (val) => val.value === vendername1
                          )}
                          placeholder={`${t("Search Vendor Name")}`}
                        />
                        <div className="invalid-feedback">
                          {errors.vendorname1 && errors.vendorname1.message}
                        </div>
                        <button
                          type="button"
                          className="btn-link add-new-link"
                          onClick={() => setState4({ isPaneOpen: true })}
                        >
                          <Plus className="btn-icon-small" />
                          Add New Vendor
                        </button>
                      </div>
                      {asset_type.length === 1 ? (
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <label className="col-lg-6 col-form-label text-left required">
                            {t("Asset Type")}{" "}
                            <Tooltip content={t("Assettype_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <input
                            type="text"
                            disabled
                            className="form-control"
                            value={asset_typesetting}
                          />
                        </div>
                      ) : (
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <label className="col-lg-6 col-form-label text-left required">
                            {t("Asset Type")}{" "}
                            <Tooltip content={t("Assettype_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <select
                            id="frequency"
                            className="form-control"
                            name="assettype"
                            value={asset_typeselection}
                            {...register("assettype", {
                              onChange: (e) => {
                                handleAssetType(e.target.value);
                              },
                              required: "Asset Type is required",
                            })}
                          >
                            <option value="">{"Select Asset Type"}</option>
                            <option value="Vehicle">{t("Vehicle")}</option>
                            <option value="Equipment">{t("Equipment")}</option>
                          </select>
                          <div className="invalid-feedback">
                            {errors.assettype && errors.assettype.message}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-md-6 mb-3 mb-md-0">
                        <label className="col-form-label required">
                          {t("Asset Cost")}{" "}
                          <Tooltip content={t("VehicleCost_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="input-group">
                          <span
                            className="input-group-text"
                            style={{ height: "35px" }}
                          >
                            $
                          </span>
                          <CurrencyInput
                            id="input-example"
                            className="form-control"
                            {...register("vehiclecost", {
                              required: "Asset cost is required",
                              validate: {
                                positive: (v) =>
                                  parseInt(v) > 0 ||
                                  "Only positive numbers are allowed",
                              },
                            })}
                            allowDecimals="false"
                            value={vehicle_cost}
                            onValueChange={(value) => hanldevehiclecost(value)}
                            name="vehiclecost"
                            disableAbbreviations
                          />
                        </div>
                        <div className="invalid-feedback">
                          {errors.vehiclecost && errors.vehiclecost.message}
                        </div>
                      </div>
                      <div className="col-md-6 position-relative">
                        <label className="col-form-label required">
                          {t("Asset Description")}{" "}
                          <Tooltip content={t("AssetDesc_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="input-group">
                          <input
                            placeholder={t("Asset Description")}
                            className="form-control"
                            type="text"
                            name="asset_desc"
                            maxLength="200"
                            id="asset_desc"
                            value={asset_desc}
                            {...register("asset_desc", {
                              onChange: (e) => {
                                handleDescription(e.target.value);
                              },
                              required: "Asset description is required",
                            })}
                          />
                          <span className="input-group-text">
                            <Search
                              className="search-icon"
                              onClick={handleExitingInventory}
                            />
                          </span>
                          <div className="invalid-feedback">
                            {errors.asset_desc && errors.asset_desc.message}
                          </div>
                        </div>
                        <button
                          type="button"
                          className="btn-link add-new-link ms-3"
                          onClick={() => {
                            setState3({ isPaneOpen: true });
                          }}
                        >
                          <Plus className="btn-icon-small me-1" />
                          Add New Asset
                        </button>
                      </div>
                      <div className="col-sm-6 position-relative">
                        <label className="col-form-label ">{t('Category')} <Tooltip content={t('Category_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                        <select
                          className="form-control"
                          name="category"
                          // onChange={(e)=>{handleCategoryChange(e)}}
                          {...register("category", { onChange: (e) => { handleCategoryChange(e) }, required: false })}
                          value={selected_category}
                        >
                          <option value="">Select Category</option>
                          {category_list.map((val, i) => (
                            <option key={i} value={val.id}>
                              {val.category_name}
                            </option>
                          ))}
                        </select>
                        <div className="invalid-feedback">
                          {errors.category?.type === 'required' && "Category  is required"}
                        </div>
                      </div>
                      <div className="col-sm-6 position-relative">
                        <label className="col-form-label ">{t('Sub Category')} <Tooltip content={t('Sub_category_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                        <select
                          className="form-control"
                          name="subcategory"
                          value={selected_sub_category}
                          {...register("subcategory", { onChange: (e) => { handlesubCategoryChange(e) }, required: false })}
                        >
                          <option value="">Select Subcategory</option>
                          {sub_categories.map((val) => (
                            <option key={val.id} value={val.id}>
                              {val.sub_category_name}
                            </option>
                          ))}
                        </select>
                        <div className="invalid-feedback">
                          {errors.subcategory?.type === 'required' && "Subcategory  is required"}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {currentStep === 3 && (
                  <div className="form-section">
                    <h2 className="section-title">Payment Details</h2>

                    <div className="row mb-4">
                      <div className="col-md-6 mb-3 mb-md-0">
                        <label className="col-form-label required">
                          {t("Frequency")}{" "}
                          <Tooltip content={t("Frequency_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <select
                          id="frequency"
                          className="form-control"
                          name="frequency"
                          value={frequency}
                          {...register("frequency", {
                            onChange: (e) => {
                              setFrequency(e.target.value);
                            },
                            required: true,
                          })}
                        >
                          <option value="">{t("Select Frequency")}</option>
                          <option value="Monthly">{t("Monthly")}</option>
                          <option value="Quarterly">{t("Quarterly")}</option>
                          <option value="Semi-annual">
                            {t("Semi-annual")}
                          </option>
                          <option value="Annual">{t("Annual")}</option>
                        </select>
                        <div className="invalid-feedback">
                          {errors.frequency && "Frequency is required"}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Payment Rule")}{" "}
                          <Tooltip content={t("PaymentRule_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <select
                          id="paymentrule"
                          className="form-control"
                          name="paymentrule"
                          value={paymentrule}
                          {...register("paymentrule", {
                            onChange: (e) => {
                              setPaymentRule(e.target.value);
                            },
                            required: true,
                          })}
                        >
                          <option value="">{t("Select Payment Rule")}</option>
                          <option value="Advance">{t("Advance")}</option>
                          <option value="Arrears">{t("Arrears")}</option>
                        </select>
                        <div className="invalid-feedback">
                          {errors.paymentrule && "Payment Rule is required"}
                        </div>
                      </div>
                    </div>

                    <div className="row mb-4">
                      <div className="col-md-6 mb-3 mb-md-0">
                        <label className="col-form-label required">
                          {t("Payment Start Date")}{" "}
                          <Tooltip content={t("StartDate_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          className="form-control "
                          value={Helper.DateNormal(paymentstart_date)}
                          disabled
                        ></input>
                      </div>

                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Payment Amount")}{" "}
                          <Tooltip content={t("PaymentAmount_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="align-items-center">
                          <div className="input-group">
                            <span
                              className="input-group-text"
                              style={{ height: "35px" }}
                            >
                              $
                            </span>
                            {rowsData.length > 1 ? (
                              <input
                                className="form-control"
                                value="Multiple"
                                disabled={true}
                              />
                            ) : (
                              <CurrencyInput
                                className="form-control"
                                {...register("paymentamount", {
                                  required:
                                    isDisabled === true
                                      ? false
                                      : "Payment amount is required",
                                  validate:
                                    isDisabled === true
                                      ? false
                                      : {
                                        positive: (v) =>
                                          parseInt(v) > 0 ||
                                          "Only positive numbers are allowed",
                                      },
                                })}
                                onValueChange={(value) => setAmount(value)}
                                name="paymentamount"
                                id="input-example"
                                allowDecimals="false"
                                disableAbbreviations
                                disabled={isDisabled}
                                value={amount}
                              />
                            )}
                          </div>
                          <button
                            type="button"
                            className="btn-link add-new-link ms-3"
                            onClick={() => setState5({ isPaneOpen: true })}
                          >
                            <Plus className="btn-icon-small me-1" />
                            Add New Payment
                          </button>
                        </div>
                        <div className="invalid-feedback">
                          {errors.paymentamount && errors.paymentamount.message}
                        </div>

                      </div>
                      <div className="row mb-4">
                        <div className="col-md-6 mb-3 mb-md-0">
                          <label className="col-form-label">
                            {t("ACH Payments")}{" "}
                            <Tooltip content={t("ACH_Payments_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="achPayments"
                              checked={achPayments}
                              {...register("achPayments", {
                                onChange: (e) => setAchPayments(e.target.checked),
                              })}
                            />
                            <label className="form-check-label" htmlFor="achPayments">
                              Enable ACH Payments
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label className="col-form-label ">
                            {t("Bank Account")}{" "}
                            <Tooltip content={t("Bank_Account_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <select
                            className="form-control"
                            id="achAccount"
                            {...register("achAccount", {
                              required: achPayments ? "Bank Account is required when ACH Payments is enabled" : false,
                              onChange: (e) => setAchAccount(e.target.value),
                            })}
                            value={achAccount}
                            disabled={!achPayments || achAccounts.length === 0}
                          >
                            <option value="">Select Bank Account</option>
                            {achAccounts.map((account) => (
                              <option key={account.id} value={account.id}>
                                {account.account_name || `Account ${account.id}`}
                              </option>
                            ))}
                          </select>
                          <div className="invalid-feedback">
                            {errors.achAccount && errors.achAccount.message}
                          </div>
                        </div>
                      </div>
                      {(rowsData.length !== 0 ||
                        amount !== null ||
                        amount > 0 ||
                        amount === undefined) && (
                          <div className="col-xl-12 col-lg-6 col-md-6 col-sm-12">
                            {/* <label className="col-lg-6 col-form-label text-left required">
                                                            <Tooltip content={t("StartDate_Tooltip")}>
                                                              <i className="fa fa-light fa-circle-info"></i>
                                                            </Tooltip>
                                                          </label> */}
                            <MaterialTable
                              // tableRef={tableRef}
                              style={{
                                backgroundColor: "var(--bs-table-bg)",
                                borderBottomWidth: "1px",
                                boxShadow:
                                  "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                              }}
                              title={
                                <label className="col-lg-6 col-form-label text-left">
                                  {t("Preview Payment Amounts")}{" "}
                                  <Tooltip content={t("Preview Payment Amounts")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                              }
                              columns={[
                                {
                                  title: `${t("No. of Payments")}`,
                                  field: "no_of_payments",
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                  render: (rowData) => (
                                    <>
                                      {" "}
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("No. of Payments")}
                                      </div>
                                      <div>{rowData.no_of_payments}</div>
                                    </>
                                  ),
                                },
                                {
                                  title: `${t("Payment Type")}`,
                                  field: "payment_type",
                                  render: (rowData) => (
                                    <>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Payment Type")}
                                      </div>{" "}
                                      <div>{rowData.payment_type === "Rent" ? "Payment" : rowData.payment_type}</div>
                                    </>
                                  ),
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                },
                                {
                                  title: `${t("Amount")}`,
                                  field: "amount",
                                  render: (rowData) => (
                                    <>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("Amount")}
                                      </div>
                                      <div>{Helper.Amount(rowData.amount)}</div>
                                    </>
                                  ),
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                },
                                {
                                  title: `${t("Start Date")}`,
                                  field: "start_date",
                                  render: (rowData) => (
                                    <>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {" "}
                                        {t("Start Date")}
                                      </div>
                                      <div>
                                        {Helper.DateNormal(rowData.start_date)}
                                      </div>
                                    </>
                                  ),
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                },
                                {
                                  title: `${t("End Date")}`,
                                  field: "end_date",
                                  render: (rowData) => (
                                    <>
                                      <div className="d-xl-none tc d-md-none d-lg-none">
                                        {t("End Date")}
                                      </div>
                                      <div>
                                        {Helper.DateNormal(rowData.end_date)}
                                      </div>
                                    </>
                                  ),
                                  headerStyle: {
                                    verticalAlign: "inherit",
                                    fontWeight: "bold",
                                    textAlign: "left",
                                  },
                                  cellStyle: {
                                    textAlign: "left",
                                    fontSize: 12,
                                  },
                                },
                              ]}
                              data={rowsData}
                              localization={{
                                toolbar: {
                                  searchPlaceholder: "Search Contracts",
                                },
                              }}
                              options={{
                                headerStyle: {
                                  backgroundColor: "white",
                                  color: "#245C7F",
                                  fontSize: 11,
                                },
                                rowStyle: (rowData, index) => {
                                  if (index % 2) {
                                    return { backgroundColor: "#fff" };
                                  }
                                },
                                sorting: true,
                                search: false,
                                toolbar: true,
                                paging: true,
                                pageSize: 3, // make initial page size
                                emptyRowsWhenPaging: false, // To avoid of having empty rows
                                pageSizeOptions: [3, 5, 10, 20, 25, 50],
                                paginationType: "stepped",
                                showFirstLastPageButtons: false,
                                exportAllData: false,
                                exportButton: false,
                                actionsColumnIndex: -1,
                              }}
                            />
                            {/* <table className="table table-bordered">
                                                            <thead>
                                                              <tr>
                                                                <th style={{ color: '#245C7F', border: '1px solid #ddd' }}>No. of Payments</th>
                                                                <th style={{ color: '#245C7F', border: '1px solid #ddd' }}>Payment Type</th>
                                                                <th style={{ color: '#245C7F', border: '1px solid #ddd' }}>Start Date</th>
                                                                <th style={{ color: '#245C7F', border: '1px solid #ddd' }}>End Date</th>
                                                                <th style={{ color: '#245C7F', border: '1px solid #ddd' }}>Amount</th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              {rowsData.map((row, index) => (
                                                                <tr key={index}>
                                                                  <td style={{ border: '1px solid #ddd' }}>{row.no_of_payments}</td>
                                                                  <td style={{ border: '1px solid #ddd' }}>{row.payment_type === "Rent" ? "Payment" : row.payment_type}</td>
                                                                  <td style={{ border: '1px solid #ddd' }}>{Helper.DateNormal(row.start_date)}</td>
                                                                  <td style={{ border: '1px solid #ddd' }}>{Helper.DateNormal(row.end_date)}</td>
                                                                  <td style={{ border: '1px solid #ddd' }}>{row.amount}</td>
                                                                </tr>
                                                              ))}
                                                            </tbody>
                                                          </table> */}
                          </div>
                        )}
                    </div>
                    {extrafiledcontract.length === 0 ? (
                      ""
                    ) : (
                      <h5
                        className="tc mt-4 cursor-pointer"
                        onClick={toggleFields}
                      >
                        {t("Additional Information")}{" "}
                        {isExpanded === true ? <FaAngleUp /> : <FaAngleDown />}
                      </h5>
                    )}
                    {isExpanded === true && (
                      <div className="form-group row">
                        {extrafiledcontract.map((key, index) => (
                          <div
                            className={
                              key.enable === "True" ? "col-sm-6" : null
                            }
                          >
                            <>
                              <label
                                style={{
                                  display:
                                    key.enable === "True" ? true : "none",
                                }}
                                className="col-form-label"
                              >
                                {" "}
                                {key.label}{" "}
                                <Tooltip content={key.label}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                style={{
                                  display:
                                    key.enable === "True" ? true : "none",
                                }}
                                className="form-control mb-1"
                                name={"attribute" + index}
                                type={key.datatype}
                                placeholder={key.label}
                                onChange={(e) => onChangeextrafileds(e, index)}
                              />
                            </>
                          </div>
                        ))}
                      </div>
                    )}
                    <input
                      type="hidden"
                      value="Entered"
                      className="form-control"
                      name="status"
                      id="status"
                      disabled
                    />
                    <input
                      type="hidden"
                      className="form-control"
                      name="sign_date"
                      id="signdate"
                    />
                    <textarea
                      style={{ display: "none" }}
                      className="form-control"
                      id="description"
                      name="description"
                    ></textarea>
                    <input
                      type="hidden"
                      style={{ display: "none" }}
                      value="USD"
                      className="form-control"
                      name="currency"
                      id="currency"
                    />
                  </div>
                )}

                {currentStep === 4 && (
                  <>
                    {/* <h6 className="fw-bold mb-4">{t("Party Role")}</h6>
                                       <div className="row">
                                                 <div className="col-md-6 mt-2">
                                                     <div className="col-lg-12">
                                                         <label className="col-form-label ">
                                                                 {t("Party")}{" "}
                                                                 <Tooltip content={t("Party_Tooltip")}>
                                                                 <i className="fa fa-light fa-circle-info"></i>
                                                                 </Tooltip>
                                                             </label>
                                           <AsyncSelect
                                             {...register("selectedParty", {
                                              //  required: "Party is required",
                                               required: false,
                                             })}
                                             defaultOptions={partyoptions}
                                             isClearable
                                             placeholder={t("Search for Party(%for All)")}
                                             options={partyoptions}
                                             value={partyoptions.find(
                                               (option) => option.id === selectedParty
                                             )}
                                             getOptionLabel={(e) => e.customer_name}
                                             getOptionValue={(e) => e.customer_name}
                                             loadOptions={loadOptionsparty}
                                             onInputChange={handelInputChangeparty}
                                             onChange={handelChangeparty}
                                             name="selectedParty"
                                           ></AsyncSelect>
                                           <div className="invalid-feedback">
                                             {errors.selectedParty && errors.selectedParty.message}
                                           </div>
                                         </div>
                                                 </div>
                                                 <div className="col-md-6 mt-2">
                                                     <div className="form-group">
                                                         <label className="col-form-label ">
                                                                 {t("Role")}{" "}
                                                                 <Tooltip content={t("Role_Tooltip")}>
                                                                 <i className="fa fa-light fa-circle-info"></i>
                                                                 </Tooltip>
                                                             </label>
                                                          <select
                                                             onChange={(e) => setRole(e.target.value)}
                                                             id="role"
                                                             className="form-control"
                                                         >
                                                             <option value="">{t("Select")}</option>
                                                             <option value="GUARANTOR">{t("Guarantor")}</option>
                                                             <option  value="INSURANCE_PROVIDER">{t("Insurance Provider")}</option>
                                                             <option  value="PRIVATE_LABEL_HOLDER">{t("Private Label Holder")}</option>
                                                         </select>
                                                     </div>
                                                 </div>
                                                 </div> */}
                    <div className="form-section">
                      <h6 className="fw-bold mb-4">{t("Party Role")}</h6>
                      <div className="row mb-4">
                        <div className="col-md-5" style={{ zIndex: 999 }}>
                          <label className="col-form-label">{t("Party")}</label>
                          <AsyncSelect
                            {...register("selectedParty", {
                              required: false, // Validation handled by addPartyRole
                            })}
                            defaultOptions={partyOptions}
                            isClearable
                            placeholder={t("Search for Party (% for All)")}
                            options={partyOptions}
                            value={selectedParty}
                            getOptionLabel={(e) => e.customer_name}
                            getOptionValue={(e) => e.id}
                            loadOptions={loadOptionsparty}
                            onInputChange={handelInputChangeparty}
                            onChange={handelChangeparty}
                            name="selectedParty"
                          />
                          <div className="invalid-feedback">
                            {errors.selectedParty && errors.selectedParty.message}
                          </div>
                          <button
                            type="button"
                            className="btn-link add-new-link"
                            // onClick={() => setState1({ isPaneOpen: true })}
                            onClick={() => { setAddCustomerSource('step4'); setState1({ isPaneOpen: true }); }}
                          >
                            <Plus className="btn-icon-small" />
                            Add New Customer
                          </button>
                        </div>
                        <div className="col-md-5">
                          <label className="col-form-label">{t("Role")}</label>
                          <select
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                            className="form-control"
                          >
                            <option value="">{t("Select")}</option>
                            {rolesList.map((r) => (
                              <option key={r} value={r}>
                                {r}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-md-2 d-flex align-items-end">
                          <button type="button" onClick={addPartyRole} className="btn btn-primary">
                            Add
                          </button>
                        </div>
                        <div className="col-md-5">
                          <label className="col-form-label">
                            {t("Comment")}{" "}
                            <Tooltip content={t("comment_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                          <div className="input-group">
                            <input
                              placeholder={t("Enter comment")}
                              className="form-control"
                              type="text"
                              name="comment"
                              maxLength="200"
                              id="comment"
                              value={comment}
                              onChange={(e) => setComment(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      {/* {partyRoles.length > 0 && ( */}
                      <MaterialTable
                        title={t("Party Role")}
                        // title={t("")}
                        columns={[
                          { title: t("Party"), field: "partyName", render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Party")}</div><div>{rowData.partyName ? rowData.partyName : ""}</div></> },
                          { title: t("Role"), field: "role", render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Role")}</div><div>{rowData.role ? rowData.role : ""}</div></> },
                          { title: t("Comment"), field: "comment", render: rowData => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Comment")}</div><div>{rowData.comment ? rowData.comment : ""}</div></> },
                        ]}
                        data={partyRoles}
                        actions={[
                          {
                            //  icon: 'delete',
                            icon: () => <span ><img src={process.env.PUBLIC_URL + '/static/images/ic-delete.svg'} alt="Edit" /></span>,
                            tooltip: 'Delete',
                            onClick: (event, rowData) => deletePartyRole(partyRoles.indexOf(rowData)),
                          },
                        ]}
                        options={{
                          actionsColumnIndex: -1,
                          paging: false,
                          search: false,
                          headerStyle: {
                            backgroundColor: "white",
                            color: "#245C7F",
                            fontSize: 11,
                          },
                          rowStyle: (rowData, index) => ({
                            backgroundColor: index % 2 ? "#fff" : "#f8f9fa",
                          }),
                        }}
                      />
                      {/* )} */}
                    </div>
                  </>
                )}

                {currentStep === 5 && (
                  <div className="form-section">
                    <h6 className="fw-bold mb-4">{t("Terms & Conditions")}</h6>

                    <div className="row mb-4">

                      {/* TERM NAME */}
                      <div className="col-md-5">
                        <label className="col-form-label">{t("Term Name")}</label>
                        <select
                          className="form-control"
                          value={selectedTermName}
                          onChange={(e) => handleTermsChange(e.target.value)}
                        >
                          <option value="">{t("Select")}</option>
                          {termsList.map((t) => (
                            <option key={t.id} value={t.name}>
                              {t.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* VALUE */}
                      <div className="col-md-5">
                        <label className="col-form-label">{t("Value")}</label>
                        <textarea
                          className="form-control"
                          value={selectedTermValue}
                          onChange={(e) => setSelectedTermValue(e.target.value)}
                        />
                      </div>

                      {/* ADD BUTTON */}
                      <div className="col-md-2 d-flex align-items-end">
                        <button type="button" onClick={addTerm} className="btn btn-primary">
                          Add
                        </button>
                      </div>

                    </div>

                    {/* TABLE */}
                    <MaterialTable
                      title={t("Terms & Conditions")}
                      columns={[
                        {
                          title: t("Term"),
                          field: "name",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Term")}
                              </div>
                              <div>{rowData.name}</div>
                            </>
                          ),
                        },
                        {
                          title: t("Value"),
                          field: "value",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Value")}
                              </div>
                              <div>{rowData.value}</div>
                            </>
                          ),
                        },
                      ]}
                      data={contractTerms}
                      actions={[
                        {
                          icon: () => (
                            <img
                              src={process.env.PUBLIC_URL + "/static/images/ic-delete.svg"}
                              alt="delete"
                            />
                          ),
                          tooltip: "Delete",
                          onClick: (event, rowData) =>
                            deleteTerm(contractTerms.indexOf(rowData)),
                        },
                      ]}
                      options={{
                        actionsColumnIndex: -1,
                        paging: false,
                        search: false,
                        headerStyle: {
                          backgroundColor: "white",
                          color: "#245C7F",
                          fontSize: 11,
                        },
                        rowStyle: (rowData, index) => ({
                          backgroundColor: index % 2 ? "#fff" : "#f8f9fa",
                        }),
                      }}
                    />
                  </div>
                )}

                <div className="form-actions">
                  <div>
                    {currentStep > 1 && (
                      <button
                        type="button"
                        onClick={prevStep}
                        className="btn btn-outline-secondary"
                      >
                        Previous
                      </button>
                    )}
                  </div>

                  <div className="action-buttons">
                    <button
                      type="button"
                      className="btn btn-outline-secondary me-2"
                      onClick={handelCancelClick}
                    >
                      Cancel
                    </button>

                    {currentStep < totalSteps ? (
                      <button
                        type="button"
                        onClick={handleNextClick}
                        className="btn btn-primary"
                      >
                        Next
                        <ArrowRight className="btn-icon" />
                      </button>
                    ) : (
                      <button type="submit" className="btn btn-primary">
                        <Save className="btn-icon" />
                        Save
                      </button>
                    )}
                    <CheckButton style={{ display: "none" }} ref={checkBtn} />
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
        {/* Contract Summary - Right Side */}
        <div className="col-lg-4 col-md-12">
          <ContractLeaseSummary
            state="Rental"
            currentStep={currentStep}
            totalSteps={totalSteps}
            data={options}
            contract_number={contract_number}
            selectedCustomer={selectedValue}
            billToAddress={filterBill}
            address_id={address_id}
            installAddress={filteredOptions}
            reg_address1={reg_address1}
            start_date={start_date}
            contract_term={contract_term}
            vendorName={filteredVendor}
            vender={vendername1}
            asset_typeselection={asset_typeselection}
            vehicle_cost={vehicle_cost}
            asset_desc={asset_desc}
            frequency={frequency}
            paymentrule={paymentrule}
            paymentstart_date={paymentstart_date}
            amount={amount}
            rowsData={rowsData}
            achPayments={achPayments}
            achAccount={achAccounts.find((acc) => acc.id === achAccount)?.account_name || ""}
            appOriginator={appOriginator}
            source={source}
            salesRep={salesRep}
            subcompany={subcompanyOptions.find((sub) => sub.id === parseInt(subcompany))?.sub_company_name}
            lineOfBusiness={lineOfBusinessOptions.find((lob) => lob.id === parseInt(lineOfBusiness))?.lob_name}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateRental;
